import axios from "axios";
import * as url from "../../helpers/url_helper";
import {
  deleteCampaign, deleteCreative, getAdTypesData, getCampaignsData, getCampaignsUsersData, getCategoriesData, getCommentsData,
  getCreativesData, getDynamicTextData, getFigmaObj, getFontListData, getTemplateCreativesData, getTemplateData, getUploadLimitsData, getVersionsData, postApproveCreatives,
  postCampaign, postCampaignMoveToFolder, postComment, postCreative, postCreativeSize, postDuplicateCampaign,
  postDuplicateCreative,
  postDuplicateVersion, postDynamicText, postTemplate, postTemplateCreatives, postUploadAsset, postUploadImage, postVersion, postVersionConnectFeed, putCampaignData, putCreative, putDynamicText, putVersion
} from "../../helpers/backend_helper";
import { getAllLibrariesErr, getAllLibrariesSuccess, setCreatives, getVersionsSuccess, setCampaignUsers, setComments, setCreativeApprovement, setCurrentVersion, setTemplateFilter, setTemplateLoader, setUploadLimits, resetVersionDetails, setSelectedTemplate, setCurrentCampaign, setActiveDynamicText, setDynamicText, updateCreativeFigmaAfterDynamicText, setSelectedCreative, setFilteredFontList, updateCreativeFigmaFonts, setSelectedFeedConnection, setConnectedFeed, setDuplicateErr, setCreativeCommentCount, resetFacebook, setFilteredTemplateCreatives, setIsApplyAll, setCampaignLoader, setFontNotUploaded, resetCampaignState, updateCreativeNodeKeyFont, updateCreativeSetFont, checkCreativeFontUploaded, setDynamicVideoError, setAllLibrariesPage, setAllLibrariesHasMore, setScrolledCreatives, setCreativesHasMore, setCreativesLoading, setCreativesFirstLoad, setCreativesPage, setAllLibrariesFirstLoad, setAllLibrariesShowLoader, updateCreativeDynamicLoopAfterFeedDisconnect, setConnectedFeedName, setFilteredCreatives } from "./reducer";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setPreloader } from "../layouts/reducer";
import { resetSelectedItems } from "../folder/reducer";
import { cleanString, formatBytes, getStyleValue, isURL, processAdTypes, sleep, sortAlphabetically, updateAllHistoryStateByMatchingCondition } from "../../slices/helper";
import { goBack, push, replace } from "redux-first-history";
import api from '../../config';
import { setBreadcrumb, setCampaignPath } from "../auth/menu/reducer";
import { setBrandPath, setClientPath, setMarketPath } from "../auth/menu/thunk";
import { createLinkForDynamicTextFont, filterCreativesByIdArray, getFontNamesFromDynamicText, sendMessageForPreview, setConnectedFeedValueBeforePreview, setConnectedFeedValueInFigmaObj, updateAllCreativesPoster } from "./helper";
import { resetModalState, toggleDuplicateNewSizeCreativeModal, toggleFeedConnectionModal, togglePluginLoader, toggleSelectPathModal } from "../modals/reducer";
import { getFeedInfo, getFeedName, getPreviewWithoutAuth } from "../feeds/thunk";
import { getFeedInfoSuccess, getFeedSuccess, setPreview } from "../feeds/reducer";
import { resetShowcase } from "../showcase/thunk";
import { setUploadedFiles } from "../uploads/reducer";
import { getUploadLimits, sendUploadFiles } from "../uploads/thunk";
import { toast } from "react-toastify";
import { getFacebookProperties } from "./facebook/thunk";
import { sortByWidth } from "../../slices/helper";
import { setVersions } from "../analytics/reducer";
import { checkMaintenance } from "../auth/login/helper";
import { loadFonts } from "../fonts/thunk";
const apiUrl = api[api.status].apiUrl;
const previewUrl = api[api.status].previewUrl;
import Cookies from 'js-cookie';

//Campaigns
export const getCampaigns = createAsyncThunk("campaigns/getCampaignsData", async (isReplace = true, { dispatch, getState }) => {
  try {
    const { clientPath, brandPath, marketPath, folderPath, title } = getState().MenuData;
    const { query, publish, user, sizes } = getState().Campaign.filter;
    const { allLibraries, allLibrariesPage } = getState().Campaign;
    let folderId = folderPath;
    let hasMore = true;
    let page = allLibrariesPage;
    if (folderPath === null) {
      folderId = 'all';
    }
    let data = [];
    if (folderId !== 'all') {
      const response = await getCampaignsData({
        brandId: brandPath,
        marketId: marketPath,
        folderId: folderId,
        query: query,
        publish: publish,
        user: user,
        sizes: sizes,
      });
      if (response.status === 'err' && response.message.includes('restricted')) {
        Cookies.remove('lastLocation');
        throw response;
        // return [];
      }
      data = response.data;
    } else {
      while ((data.length * 50) <= window.innerHeight) {
        const response = await getCampaignsData({
          brandId: brandPath,
          marketId: marketPath,
          folderId: folderId,
          query: query,
          publish: publish,
          user: user,
          sizes: sizes,
          page: page
        });
        page++;

        if (response.status === 'err' && response.message.includes('restricted')) {
          Cookies.remove('lastLocation');
          throw response;
          // return []
        }
        if (response.data.length === 0) {
          break;
        }
        data.push(...response.data);
      }
      dispatch(setAllLibrariesPage(page));
    }
    if (data.length === 0) {
      hasMore = false;
    }
    const usersResponse = await getCampaignsUsersData({ brandId: brandPath });
    dispatch(resetSelectedItems());
    dispatch(setCampaignUsers(usersResponse.data));
    dispatch(setAllLibrariesHasMore(hasMore));
    if (isReplace) {
      dispatch(replace(window.location.href, { title: title, campaings: data, hasMore: hasMore, firstLoad: false, campaignsPage: page }));
    }
    return data;
  } catch (error) {
    if (error.status === 'err' && error.message.includes('restricted')) {
      setTimeout(() => {
        Cookies.remove('lastLocation');
        dispatch(replace('/out-of-permission', null));
      }, 1);
      return [];
    }
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
});

export const getCampaignsByPage = createAsyncThunk("campaigns/getCampaignsDataByPage", async (page, { dispatch, getState }) => {
  try {
    const { clientPath, brandPath, marketPath, folderPath } = getState().MenuData;
    const { allLibraries, allLibrariesPage } = getState().Campaign;
    const { query, publish, user, sizes } = getState().Campaign.filter;
    if (allLibraries && allLibraries.length > 0) {
      let folderId = folderPath
      if (query !== null && folderPath === null) {
        folderId = 'all';
      }
      const response = await getCampaignsData({
        brandId: brandPath,
        marketId: marketPath,
        folderId: folderId,
        query: query,
        publish: publish,
        user: user,
        sizes: sizes,
        page: page
      });
      return response.data;
    } else {
      return [];
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
    return [];
  }
})

export const getAdTypes = createAsyncThunk("campaigns/getAdTypesData", async (data, { dispatch, getState }) => {
  try {
    let response = await getAdTypesData();
    let adTypes = processAdTypes(response.data);

    return adTypes;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
})

export const createCampaign = (data) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { user } = getState().Login;
    const campaigns = getState().Campaign.allLibraries;
    const { client, folderPath } = getState().MenuData;
    const response = await postCampaign({ ...data, subOf: folderPath, companyId: client._id });
    if (response.status === 'ok') {

      await dispatch(setClientPath(data.clientId));
      await dispatch(setBrandPath(data.brandId));
      await dispatch(setMarketPath(data.marketId));
      const newCampaignObj = {
        ...data,
        subOf: (folderPath ? folderPath : null),
        creatives: 0,
        versions: 0,
        createdDate: Date.now(),
        modifiedDate: Date.now(),
        status: 0,
        published: 0,
        userId: user.data.userId,
        _id: response.data.insertedId
      };
      const updatedCampaigns = [...campaigns, newCampaignObj];
      dispatch(getAllLibrariesSuccess(updatedCampaigns));
      dispatch(replace(window.location.href, { campaigns: updatedCampaigns }));
      dispatch(openCampaign(newCampaignObj));
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
};

export const openCampaign = (campaign, version) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { client, title } = getState().MenuData;
    const {
      currentCampaign,
      allLibraries,
      allLibrariesHasMore,
      allLibrariesFirstLoad,
      allLibrariesPage,
    } = getState().Campaign;
    dispatch(resetModalState());
    dispatch(resetCampaignState())
    dispatch(resetShowcase());
    dispatch(resetFacebook());
    dispatch(resetVersionDetails());
    dispatch(setUploadedFiles([]));
    dispatch(setSelectedTemplate(null));
    dispatch(setSelectedCreative(null));
    dispatch(setSelectedFeedConnection(null));
    dispatch(setConnectedFeed(null));
    dispatch(getFeedInfoSuccess(null));
    dispatch(setPreview([]));
    dispatch(setScrolledCreatives([]));
    dispatch(setCreativesHasMore(true));
    dispatch(setCreativesLoading(false));
    dispatch(setCreativesFirstLoad(true));
    dispatch(setCreativesPage(1));
    dispatch(getFeedSuccess(null));
    // dispatch(setPreloader(true));
    dispatch(setCampaignLoader(true));
    dispatch(setCurrentCampaign(campaign));
    dispatch(setCampaignPath(campaign._id));
    let facebookPropertiesVar, connectedFeedVar, connectedFeedNameVar, dynamicTextVar, activeDynamicTextVar, fontResVar, previewFontsVar, creativesVar;
    const vRes = await dispatch(getVersions(campaign._id));
    const uploadRes = await dispatch(getUploadLimits());
    let versionData;
    if (vRes.payload.length > 0) {
      if (version) {
        versionData = version;
      } else {
        versionData = vRes.payload[0];
      }
      dispatch(setCurrentVersion(versionData));
      if (campaign.bannerType === 'html' || campaign.adType === 'social') {
        if (campaign.adType === 'social') {
          const { facebookProperties, connectedFeed, connectedFeedName, dynamicText, activeDynamicText, fontRes, previewFonts, creatives } = await dispatch(openFacebookSocial(versionData));
          facebookPropertiesVar = facebookProperties;
          connectedFeedVar = connectedFeed;
          connectedFeedNameVar = connectedFeedName;
          dynamicTextVar = dynamicText;
          activeDynamicTextVar = activeDynamicText;
          fontResVar = fontRes;
          previewFontsVar = previewFonts;
          creativesVar = creatives;
        } else {
          const { connectedFeed, connectedFeedName, dynamicText, activeDynamicText, fontRes, previewFonts, creatives } = await dispatch(openDisplayHtml(versionData));
          connectedFeedVar = connectedFeed;
          connectedFeedNameVar = connectedFeedName;
          dynamicTextVar = dynamicText;
          activeDynamicTextVar = activeDynamicText;
          fontResVar = fontRes;
          previewFontsVar = previewFonts;
          creativesVar = creatives;
        }

      } else {
        // await dispatch(getCreatives(vRes.payload[0]._id));
        const { creatives } = await dispatch(openDisplayImage(versionData));
        creativesVar = creatives;
      }
    } else if (campaign.bannerType !== 'image') {
      const fontRes = await dispatch(getFontList());
      fontResVar = (fontRes.payload ? fontRes.payload : []);
    }
    const foundClient = client.clients.find(item => item._id === campaign.clientId)
    const foundClientName = foundClient.clientName.toLowerCase().replaceAll(/\s+/g, "-");
    const foundBrand = foundClient.brands.find(item => item._id === campaign.brandId)
    const foundBrandName = foundBrand.name.toLowerCase().replaceAll(/\s+/g, "-");
    const foundMarket = foundBrand.markets.find(item => item._id === campaign.marketId)
    const foundMarketName = foundMarket.name.toLowerCase().replaceAll(/\s+/g, "-");
    const campaignPath = `/${foundClientName}/${foundBrandName}/${foundMarketName}/campaigns/${campaign._id}`;

    const newBreadcrumbTitle = { name: campaign.name, src: campaignPath };
    let updatedBreadcrumbTitle = [];
    if (title.length === 0) {
      let adLibPath = `/${foundClientName}/${foundBrandName}`;
      if (foundMarketName) {
        adLibPath += `/${foundMarketName}`;
      }
      adLibPath += '/campaigns/filter/all';
      updatedBreadcrumbTitle = [{ name: 'Ad Library', src: adLibPath }, newBreadcrumbTitle];
    } else {
      updatedBreadcrumbTitle = [...title, newBreadcrumbTitle];
    }
    dispatch(push(campaignPath, {
      campaigns: allLibraries,
      hasMore: allLibrariesHasMore,
      firstLoad: false,
      campaignPage: allLibrariesPage,
      isLoading: false,
      showLoader: false,
      currentCampaign: campaign,
      versions: vRes.payload,
      currentVersion: versionData,
      facebookProperties: facebookPropertiesVar,
      isFacebookPropertiesSet: facebookPropertiesVar ? true : false,
      facebookStatus: facebookPropertiesVar ? facebookPropertiesVar?.status : false,
      facebookCreativeIds: facebookPropertiesVar ? facebookPropertiesVar?.creativeIds : [],
      connectedFeed: connectedFeedVar,
      connectedFeedName: connectedFeedNameVar,
      dynamicText: dynamicTextVar,
      activeDynamicText: activeDynamicTextVar,
      fontRes: fontResVar,
      previewFonts: previewFontsVar,
      creatives: creativesVar,
      uploadLimits: uploadRes.payload,
      title: updatedBreadcrumbTitle
    }));
    return true;
    // dispatch(setPreloader(false));
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
};

export const openFacebookSocial = (vRes) => async (dispatch, getState) => {
  try {
    const campaign = getState().Campaign.currentCampaign;
    const { currentCampaign, currentVersion, fontUpdated } = getState().Campaign;
    let facebookProperties, connectedFeed, connectedFeedName, dynamicText, fontRes, previewFonts, creatives = [];
    facebookProperties = await dispatch(getFacebookProperties());
    if (vRes.hasOwnProperty('feeds') && Array.isArray(vRes.feeds)) {
      // const feedInfoRes = await dispatch(getFeedInfo({ id: vRes.payload[0].feeds[0], getPreview: false }));
      connectedFeed = await dispatch(getPreviewWithoutAuth(vRes.feeds[0]));
      connectedFeedName = await dispatch(getFeedName(vRes.feeds[0]));
      dispatch(setConnectedFeed(connectedFeed));
    } else {
      connectedFeed = null;
    }
    dynamicText = await dispatch(getDynamicText({ versionId: vRes._id }));
    dispatch(setActiveDynamicText((dynamicText.payload[0] ? dynamicText.payload[0] : null)));
    // const fontLinkEls = await createLinkForDynamicTextFont(dynamicText.payload, dispatch);
    const creativesRes = await dispatch(getCreatives(vRes._id));
    if (creativesRes.payload.length > 0) {
      // await dispatch(setCreativeFigmaBeforePreview());
      fontRes = await dispatch(getFontList());
      dispatch(setFilteredFontList(fontRes?.payload));
      // previewFonts = await dispatch(setPreviewFonts());
      // const checkedCreative = dispatch(checkCreativeFontUploaded({ creatives: [], isUpdated: false }));
      // dispatch(controlDynamicVideoError());
      // creatives = checkedCreative.payload.creatives;
      // if (checkedCreative.payload.isUpdated) {
      //   const uploadRes = await putCreative({ creativeArray: creatives, campaignId: currentCampaign._id });
      //   dispatch(openCampaign(currentCampaign, currentVersion));
      // }
      creatives = creativesRes.payload;
    }
    return {
      creatives: creatives,
      dynamicText: dynamicText.payload,
      activeDynamicText: (dynamicText.payload[0] ? dynamicText.payload[0] : null),
      connectedFeed,
      connectedFeedName,
      facebookProperties: (facebookProperties?.payload ? facebookProperties?.payload : null),
      previewFonts: previewFonts,
      fontRes: (fontRes?.payload ? fontRes.payload : [])
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
};

export const openDisplayHtml = (vRes) => async (dispatch, getState) => {
  try {
    const { currentCampaign, currentVersion, fontUpdated } = getState().Campaign;
    let creatives = [];
    let connectedFeed, connectedFeedName, dynamicText, fontRes, previewFonts;
    if (vRes.hasOwnProperty('feeds') && Array.isArray(vRes.feeds)) {
      // const feedInfoRes = await dispatch(getFeedInfo({ id: vRes.payload[0].feeds[0], getPreview: false }));
      connectedFeed = await dispatch(getPreviewWithoutAuth(vRes.feeds[0]));
      connectedFeedName = await dispatch(getFeedName(vRes.feeds[0]));
      dispatch(setConnectedFeed(connectedFeed));
    } else {
      connectedFeed = null;
    }
    dynamicText = await dispatch(getDynamicText({ versionId: vRes._id }));
    dispatch(setActiveDynamicText((Array.isArray(dynamicText.payload) ? dynamicText.payload[0] : null)));
    // const fontLinkEls = await createLinkForDynamicTextFont(dynamicText.payload, dispatch);
    const creativesRes = await dispatch(getCreatives(vRes._id));
    if (creativesRes.payload.length > 0) {
      // await dispatch(setCreativeFigmaBeforePreview());
      fontRes = await dispatch(getFontList());
      dispatch(setFilteredFontList(fontRes?.payload));
      // previewFonts = await dispatch(setPreviewFonts());
      // const checkedCreative = dispatch(checkCreativeFontUploaded({creatives: [], isUpdated: false}));
      // dispatch(controlDynamicVideoError());
      // creatives = checkedCreative.payload.creatives;
      // if (checkedCreative.payload.isUpdated) {
      //     const uploadRes = await putCreative({ creativeArray: creatives, campaignId: currentCampaign._id });
      //     dispatch(openCampaign(currentCampaign, currentVersion));
      // }
      creatives = creativesRes.payload;
    }
    return {
      creatives: creatives,
      dynamicText: dynamicText.payload,
      activeDynamicText: (Array.isArray(dynamicText.payload) ? dynamicText.payload[0] : null),
      connectedFeed,
      connectedFeedName,
      previewFonts: previewFonts,
      fontRes: (fontRes?.payload ? fontRes.payload : [])
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
};

export const openDisplayImage = (vRes) => async (dispatch, getState) => {
  try {
    const creatives = await dispatch(getCreatives(vRes._id));
    return { creatives: creatives.payload }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const removeCampaign = (id) => async (dispatch, getState) => {
  const { language, title } = getState().MenuData;
  try {
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesFirstLoad,
      allLibrariesPage
    } = getState().Campaign;
    const response = await deleteCampaign({ id: id });

    if (response.status === 'ok') {
      const filteredCampaigns = allLibraries.filter(campaign => campaign._id !== id);
      dispatch(getAllLibrariesSuccess(filteredCampaigns));
      dispatch(setAllLibrariesFirstLoad(false));
      dispatch(replace(window.location.href, {
        campaigns: filteredCampaigns,
        title: title,
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage
      }));
      return response;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    return error;
  }
}

export const duplicateCampaign = (item) => async (dispatch, getState) => {
  try {
    const campaigns = getState().Campaign.allLibraries;
    const { title } = getState().MenuData;
    const { allLibrariesHasMore, allLibrariesFirstLoad, allLibrariesPage } = getState().Campaign;
    const response = await postDuplicateCampaign({
      id: item._id,
      name: item.name,
      marketId: item.marketId,
      marketIcon: item?.marketIcon
    });
    if (response.status === 'ok') {
      const foundCampaign = campaigns.find(campaign => campaign._id === item._id);
      if (foundCampaign) {
        const updatedCampaigns = [
          {
            ...foundCampaign,
            name: `${foundCampaign.name} - Copy`,
            _id: response.data.insertedId,
            modifiedDate: new Date().getTime(),
            createdDate: new Date().getTime(),
          },
          ...campaigns];
        dispatch(getAllLibrariesSuccess(updatedCampaigns));
        dispatch(setAllLibrariesFirstLoad(false));
        dispatch(replace(window.location.href, {
          title: title,
          campaigns: updatedCampaigns,
          hasMore: allLibrariesHasMore,
          firstLoad: false,
          campaignPage: allLibrariesPage,
        }));
        return response;
      }
    } else {
      throw response;
    }
  } catch (error) {
    // console.log(error);
    checkMaintenance(dispatch, error);
    return error;
  }
}

export const campaignMoveToFolder = (id, folderId) => async (dispatch, getState) => {
  const { language, title } = getState().MenuData;
  try {
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesFirstLoad,
      allLibrariesPage
    } = getState().Campaign;
    const response = await postCampaignMoveToFolder({ id, folderId });
    if (response.status !== 'ok') {
      throw response;
    } else {
      const filteredCampaigns = allLibraries.filter(campaign => campaign._id !== id);
      dispatch(getAllLibrariesSuccess(filteredCampaigns));
      dispatch(setAllLibrariesFirstLoad(false));
      dispatch(replace(window.location.href, {
        campaigns: filteredCampaigns,
        title: title,
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage
      }));
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const updateCampaign = (item) => async (dispatch, getState) => {
  try {
    const title = getState().MenuData.title;
    const {
      allLibraries,
      allLibrariesHasMore,
      allLibrariesPage
    } = getState().Campaign;
    const response = await putCampaignData({ id: item._id, name: item.name });
    if (response.status === 'ok') {
      const updatedCampaigns = allLibraries.map(campaign => {
        if (campaign._id === item._id) {
          return {
            ...campaign,
            name: item.name
          }
        } else {
          return campaign;
        }
      });
      dispatch(getAllLibrariesSuccess(updatedCampaigns));
      dispatch(setAllLibrariesFirstLoad(false));
      dispatch(replace(window.location.href, {
        title: title,
        campaigns: updatedCampaigns,
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage
      }));
      return response;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    return error;
  }
}

// Versions
export const getVersions = createAsyncThunk("campaigns/getVersionsData", async (campaignId = null, { dispatch, getState }) => {
  const { language } = getState().MenuData;
  try {
    const campaignPath = getState().MenuData.campaignPath;
    const response = await getVersionsData({ id: campaignId ? campaignId : campaignPath });
    if (response.status === 'ok') {
      return response.data;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    dispatch(setPreloader(false));
    dispatch(setTemplateLoader(false));
    dispatch(setCampaignLoader(false));
    toast.error(error.message, { autoClose: 3000 });
  }
})

export const createVersion = (data) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { currentCampaign } = getState().Campaign;
    const uploadImageResponse = await dispatch(sendUploadFiles(data.size));
    if (Array.isArray(uploadImageResponse)) {
      const versionResponse = await postVersion({
        sizes: data.size.map(item => item.pixelSize),
        campaignId: data.campaignId,
        landingPage: data.landingPage,
        name: data.name,
      });
      if (versionResponse.status === 'ok') {
        const createCreativeResponse = await dispatch(createCreative({
          versionId: versionResponse.data.insertedId,
          campaignId: data.campaignId,
          creatives: uploadImageResponse.map(item => item[0]),
          sizes: data.size.map(item => item.pixelSize),
          fileSizes: data.size.map(item => item.size)
        }));
        if (createCreativeResponse.status === 'ok') {
          dispatch(setBreadcrumb({ name: 'Ad Library', title: [] }));
          const versions = await dispatch(getVersions());
          const updatedVersion = versions.payload.find(item => item._id === versionResponse.data.insertedId);
          await dispatch(openCampaign(currentCampaign, updatedVersion));
        } else {
          throw createCreativeResponse;
        }
      } else {
        throw versionResponse;
      }
    } else {
      throw uploadImageResponse;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
};

export const createVersionHtmlTemplate = (data) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const {
      selectedTemplate,
      currentCampaign,
      connectedFeed,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      facebookId,
      creatives,
    } = getState().Campaign;
    const { uploadLimits } = getState().Upload;
    const { title } = getState().MenuData;
    // Create Version
    const versionResponse = await postVersion({
      sizes: data.size.map(item => item.pixelSize),
      campaignId: data.campaignId,
      landingPage: data.landingPage,
      name: data.name,
      templateId: selectedTemplate._id
    });
    if (versionResponse.status === "ok") {
      // Create Creative
      let createCreativeResponse;
      try {
        createCreativeResponse = await dispatch(createCreative({
          versionId: versionResponse.data.insertedId,
          campaignId: data.campaignId,
          creatives: data.size.map(item => item.path),
          sizes: data.size.map(item => item.pixelSize),
          fileSizes: data.size.map(item => item.fileSize),
          figmaObjects: data.size.map(item => item.figmaObject)
        }));  
      } catch (error) {
        await dispatch(openCampaign(currentCampaign));
        toast.error('Something went wrong.', {autoClose: 3000});
        return;
      }
      
      if (createCreativeResponse?.status === 'ok') {
        if (selectedTemplate.dynamicAreas && selectedTemplate.dynamicAreas.length > 0) {
          async function waitForDynamicText() {
            return new Promise((resolve, reject) => {
              async function messageHandler(event) {
                if (event?.data) {
                  const action = event.data.action;
                  switch (action) {
                    case "adc-get-all-dynamic-text-elements":
                      const dynamicRes = await dispatch(createDynamicText({
                        versionId: versionResponse.data.insertedId,
                        campaignId: data.campaignId,
                        texts: event.data.texts.map(item => {
                          return { name: item.name, tag: item.tag, type: item.type, value: item.value };
                        })
                      }));
                      resolve(dynamicRes);
                      break;
                  }
                }
              }

              window.addEventListener('message', messageHandler, { once: true });
            })
          }
          if (data.size[0].templatePreview && data.size[0].templatePreview.contentWindow) {
            data.size[0].templatePreview.contentWindow.postMessage({
              action: "adc-get-all-dynamic-text-elements",
              texts: selectedTemplate.dynamicAreas
            }, "*");
          }

          await waitForDynamicText();
        }
      }
      const versions = await dispatch(getVersions());
      const updatedVersion = versions.payload.find(item => item._id === versionResponse.data.insertedId);
      const dynamicTexts = await dispatch(getDynamicText({ versionId: updatedVersion._id }));
      const creativesRes = await dispatch(getCreatives(updatedVersion._id));
      dispatch(setCurrentVersion(updatedVersion));
      dispatch(push(window.location.href, {
        currentCampaign: currentCampaign,
        versions: versions.payload,
        currentVersion: updatedVersion,
        facebookProperties: null,
        isFacebookPropertiesSet: false,
        facebookStatus: false,
        facebookCreativeIds: [],
        connectedFeed: null,
        connectedFeedName: null,
        dynamicText: dynamicTexts.payload,
        activeDynamicText: (dynamicTexts.payload[0] || []),
        fontRes: filteredFontList,
        creatives: creativesRes.payload,
        uploadLimits: uploadLimits,
        title: title,
        campaignLoader: true,
      }));
      return { currentVersion: updatedVersion };
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}


export const duplicateVersion = (data) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { _id } = getState().Campaign.versionDetails;
    const {
      currentCampaign,
      connectedFeed,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      facebookId,
      creatives,
    } = getState().Campaign;
    dispatch(setCampaignLoader(true));
    const duplicateResponse = await postDuplicateVersion({ id: _id });
    let updateResponse;
    if (duplicateResponse.status === 'ok') {
      updateResponse = await dispatch(updateVersion({
        campaignId: data.campaignId,
        landingPage: data.landingPage,
        name: data.name,
        sizes: data.size.map(item => item.pixelSize),
        id: duplicateResponse.data.insertedId
      }));
      if (updateResponse.status !== 'ok') {
        throw updateResponse;
      }
    } else {
      throw duplicateResponse;
    }


    if (currentCampaign?.bannerType === 'html' && dynamicText.length > 0) {
      await dispatch(createDynamicText({
        versionId: duplicateResponse.data.insertedId,
        campaignId: currentCampaign._id,
        texts: dynamicText[0].texts
      }));
    }
    const duplicatedVersion = updateResponse.updatedVersion;
    // dispatch(push(window.location.href, {
    //   currentCampaign: currentCampaign,
    //   versions: updateResponse.versions,
    //   currentVersion: duplicatedVersion,
    //   facebookProperties: null,
    //   isFacebookPropertiesSet: false,
    //   connectedFeed: null,
    //   connectedFeedName: null,
    //   dynamicText: dynamicText,
    //   activeDynamicText: activeDynamicText,
    //   fontRes: filteredFontList,
    //   creatives: creatives.map((item) => {
    //     let returnObj = {};
    //     let keys = Object.keys(item);
    //     keys.forEach(key => {
    //       if (key !== 'preview') {
    //         returnObj[key] = item[key];
    //       }
    //     });
    //     return returnObj;
    //   }),
    //   uploadLimits: uploadLimits,
    //   title: title
    // }));
    dispatch(openCampaign(currentCampaign, duplicatedVersion));
    dispatch(setCampaignLoader(false));
  } catch (error) {
    checkMaintenance(dispatch, error);
    dispatch(setDuplicateErr(language[error?.code]));
    dispatch(setCampaignLoader(false));
  }
};

export const updateVersion = (data) => async (dispatch, getState) => {
  try {
    const { campaignPath, title } = getState().MenuData;
    const { currentCampaign, version, currentVersion, facebookProperties, connectedFeed, dynamicText, activeDynamicText, filteredFontList, creatives } = getState().Campaign;
    const response = await putVersion({
      campaignId: campaignPath,
      id: data.id,
      landingPage: data.landingPage,
      name: data.name,
      sizes: data.size
    });
    if (response.status === 'ok') {
      const versions = await dispatch(getVersions());
      const updatedVersion = versions.payload.find(item => item._id === data.id);
      dispatch(setCurrentVersion(updatedVersion));
      return { ...response, versions: versions.payload, updatedVersion: updatedVersion };
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
    return error;

  }
}

export const connectFeed = () => async (dispatch, getState) => {
  const { language, title } = getState().MenuData;
  try {
    const {
      currentVersion,
      selectedFeedConnection,
      allLibraries,
      allLibrariesHasMore,
      allLibrariesPage,
      currentCampaign,
      versions,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds,
      connectedFeed,
      connectedFeedName,
      dynamicText,
      activeDynamicText,
      creatives,
      facebookId
    } = getState().Campaign;
    const previousLocations = getState().router.previousLocations;
    const contentId = getState().Campaign.id;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brand: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    };
    if (contentId?.value && contentId.value.trim() !== '') {
      facebookProperties.properties.id = contentId;
    }
    const {
      whereToPublish,
      publishTypes,
      selectedPublishType,
      selectedCreativesPublish,
      isBusinessAuthenticated,
      fbCatalogPublishSettings,
      userFacebookId,
      businessList,
      catalogList,
      fbBusinessId,
      catalogId,
    } = getState().Publish
    const { uploadLimits } = getState().Upload;
    const res = await postVersionConnectFeed({
      versionId: currentVersion._id,
      feedId: selectedFeedConnection._id
    });
    if (res.status === 'ok') {
      dispatch(toggleFeedConnectionModal());
      // const connectedFeed = await dispatch(getFeedInfo({ id: selectedFeedConnection._id, getPreview: false }));
      const connectedFeed = await dispatch(getPreviewWithoutAuth(selectedFeedConnection._id));
      const updatedVersion = { ...currentVersion, feeds: [selectedFeedConnection._id] }
      const updatedVersions = versions.map(item => {
        if (item._id === currentVersion._id) {
          return updatedVersion;
        } else {
          return item;
        }
      });
      dispatch(setCurrentVersion(updatedVersion));
      dispatch(setConnectedFeed(connectedFeed));
      // Update All History State
      // updateAllHistoryStateByMatchingCondition(
      //   previousLocations,
      //   dispatch,
      //   {
      //     versions: updatedVersions,
      //     currentVersion: updatedVersion,
      //     connectedFeed: connectedFeed,
      //     connectedFeedName: selectedFeedConnection.name,
      //   },
      //   'currentCampaign',
      //   currentCampaign._id);
      dispatch(replace(window.location.href, {
        campaigns: allLibraries,
        hasMore: allLibrariesHasMore,
        firstLoad: false,
        campaignPage: allLibrariesPage,
        isLoading: false,
        showLoader: false,
        currentCampaign: currentCampaign,
        versions: updatedVersions,
        currentVersion: updatedVersion,
        facebookProperties: facebookProperties,
        isFacebookPropertiesSet: isFacebookPropertiesSet,
        facebookStatus: facebookStatus,
        facebookCreativeIds: facebookCreativeIds,
        connectedFeed: connectedFeed,
        connectedFeedName: selectedFeedConnection.name,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: [],
        previewFonts: [],
        creatives: (creatives || []).map((item) => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          return returnObj;
        }),
        uploadLimits: uploadLimits,
        title: title,
        // For Publish Screen
        whereToPublish: whereToPublish,
        publishList: publishTypes,
        publishType: selectedPublishType,
        facebookId: facebookId,
        selectedCreativesPublish: selectedCreativesPublish,
        creativesForPublish: (creatives || []).map((item) => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          return returnObj;
        }),
        isBusinessAuthenticated: isBusinessAuthenticated,
        fbCatalogPublishSettings: fbCatalogPublishSettings,
        userFacebookId: userFacebookId,
        businessList: businessList,
        catalogList: catalogList,
        fbBusinessId: fbBusinessId,
        catalogId: catalogId
      }));
    } else {
      throw res;
    }
  } catch (error) {
    toast.error(language[error?.code], { autoClose: 3000 });
    checkMaintenance(dispatch, error);
  }
};

export const disconnectFeed = () => async (dispatch, getState) => {
  try {
    const { currentVersion, versions } = getState().Campaign;
    const res = await postVersionConnectFeed({
      versionId: currentVersion._id,
      feedId: ""
    });

    if (res.status === 'ok') {
      dispatch(setConnectedFeed(null));
      dispatch(setConnectedFeedName(null));
      const updatedVersions = versions.map(item => {
        if (item._id === currentVersion._id) {
          return { ...currentVersion, feeds: null }
        } else {
          return item;
        }
      });
      dispatch(getVersionsSuccess(updatedVersions));
      dispatch(setCurrentVersion({ ...currentVersion, feeds: null }));
      const { dynamicText, activeDynamicText } = await dispatch(setDynamicTextAfterDisconnect());
      await dispatch(saveDynamicText(true));
      return { dynamicText, activeDynamicText }
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
};

export const setDynamicTextAfterDisconnect = () => async (dispatch, getState) => {
  try {
    const { dynamicText, activeDynamicText } = getState().Campaign;
    const prevActiveDynamicText = activeDynamicText;
    const updatedDynamicText = [];
    for (const dText of dynamicText) {
      const texts = [];
      for (const text of dText.texts) {
        if (text.isFeed === true) {
          // dispatch(setDynamicTextTag({ ...text, value: '', isFeed: false }));
          const textObj = {};
          const keys = Object.keys(text);
          keys.forEach(key => {
            if (key !== 'value' && key !== 'isFeed') {
              textObj[key] = text[key];
            }
          });
          textObj.value = '';
          textObj.isFeed = false;
          texts.push(textObj);
        } else {
          texts.push(text);
        }
      }
      updatedDynamicText.push({ ...dText, texts: texts });
    }
    let foundActiveDynamicText = updatedDynamicText[0];
    if (prevActiveDynamicText.isCreative) {
      foundActiveDynamicText = updatedDynamicText.find(dText => dText.isCreative && dText.creativeId === prevActiveDynamicText.creativeId);
    }
    dispatch(setDynamicText(updatedDynamicText));
    dispatch(setActiveDynamicText(foundActiveDynamicText));
    dispatch(setCreativesDynamicText());
    // dispatch(setAllCreativesFont());
    return { dynamicText: updatedDynamicText, activeDynamicText: foundActiveDynamicText }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const updateCreativeDynamicLoopAfterFeedDisconnectThunk = () => async (dispatch, getState) => {
  try {
    const { creatives, currentCampaign } = getState().Campaign;
    let creativesWithFigmaObj = [];
    let i = 0;
    do {
      const creative = creatives[i];
      if (creative.hasOwnProperty('figmaObject')) {
        creativesWithFigmaObj.push(creative);
      } else {
        let updatedCreative = { ...creative }
        updatedCreative.figmaObject = await getFigmaObj(updatedCreative.figma + `?timestamp=${new Date().getTime()}`);
        creativesWithFigmaObj.push(updatedCreative);
      }
      i++;
    } while (i < creatives.length);
    const creativesPayload = await dispatch(updateCreativeDynamicLoopAfterFeedDisconnect({ creatives: creativesWithFigmaObj }));
    const updatedCreatives = creativesPayload.payload.creatives;
    if (updatedCreatives && updatedCreatives.length > 0) {
      const creativeRes = await putCreative({ creativeArray: updatedCreatives, campaignId: currentCampaign._id });
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

// Creative
export const getCreatives = createAsyncThunk("campaigns/getCreativesData", async (id, { dispatch, getState }) => {
  const { language } = getState().MenuData;
  try {
    const { currentCampaign } = getState().Campaign;
    const response = await getCreativesData({ versionId: id });
    let data = [];
    if (response.status === 'ok') {
      data = response.data.map(item => {
        return { ...item, isLoading: true };
      });
      // data = sortByWidth(data, 'size');
      return data;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    return [];
  }
});

export const createPreview = (creative, version, dynamicText, feedObjects, fonts) => async (dispatch, getState) => {
  try {
    return new Promise(async (resolve, reject) => {
      const [width, height] = creative.size.split('x').map(i => i);
      const iframe = document.createElement("iframe");
      iframe.width = `${width}px`;
      iframe.height = `${height}px`;
      iframe.src = previewUrl;
      iframe.style.pointerEvents = 'none';
      iframe.style.userSelect = 'none';
      iframe.style.display = 'none';
      // iframe.src = 'http://127.0.0.1:5000/preview.html';
      document.body.appendChild(iframe);
      let creativeObj = { ...creative.figmaObject };
      creativeObj.preview = null;
      iframe.onload = () => {
        iframe.contentWindow.postMessage({
          action: 'adc-get-preview',
          previewObject: {
            ...creative.figmaObject,
            version: version,
            dynamicText: dynamicText,
            globalLoop: creative.figmaObject?.globalLoop,
            dynamicLoop: creative.figmaObject?.dynamicLoop,
            feedObjects: feedObjects,
            creativeId: creative._id
          },
          creativeId: creative._id,
          fonts: ''
        }, '*');
        resolve({ preview: iframe });
      };
    });
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const createCreative = (data) => async (dispatch, getState) => {
  try {
    const response = await postCreative(data);
    return response
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const addNewImage = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { currentCampaign, currentVersion } = getState().Campaign;
    const uploadedFiles = getState().Upload.uploadedFiles;
    const uploadImageResponse = await dispatch(sendUploadFiles(uploadedFiles));
    // Create Creative

    if (uploadImageResponse) {
      const createCreativeResponse = await dispatch(createCreative({
        versionId: currentVersion._id,
        campaignId: currentCampaign._id,
        creatives: uploadImageResponse,
        sizes: uploadedFiles.map(item => item.pixelSize),
        fileSizes: uploadedFiles.map(item => item.size)
      }));
      if (createCreativeResponse.status === 'ok') {
        const versions = await dispatch(getVersions());
        const updatedVersion = versions.payload.find(item => item._id === versionPath);
        dispatch(setCurrentVersion(updatedVersion));
      } else {
        throw createCreativeResponse;
      }
    } else {
      throw uploadImageResponse;
    }

  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });

  }
}

export const approveCreative = (ids) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const response = await postApproveCreatives({ ids });

    if (response.status === "ok") {
      dispatch(setCreativeApprovement(ids));
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const duplicateCreative = (id) => async (dispatch, getState) => {
  const { language, title } = getState().MenuData;
  try {
    const {
      currentCampaign,
      versions,
      currentVersion,
      facebookId,
      connectedFeed,
      connectedFeedName,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      creatives,
    } = getState().Campaign;
    const uploadLimits = getState().Upload.uploadLimits;
    const contentId = getState().Campaign.id;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brand: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    }
    if (contentId?.value && contentId.value.trim() !== '') {
      facebookProperties.properties.id = contentId;
    }
    dispatch(setCampaignLoader(true));
    const response = await postDuplicateCreative({ id: id });
    if (response.status === 'ok') {
      // dispatch(getCreatives(versionPath));
      const creativeRes = await dispatch(getCreatives(currentVersion._id));
      // await dispatch(setCreativeFigmaBeforePreview());
      const updateRes = await dispatch(updateVersionStatusAfterUpdate());
      dispatch(replace(window.location.href, {
        currentCampaign: currentCampaign,
        versions: updateRes.updatedVersions,
        currentVersion: updateRes.updatedVersion,
        facebookProperties: facebookProperties,
        isFacebookPropertiesSet: isFacebookPropertiesSet,
        facebookStatus: facebookStatus,
        facebookCreativeIds: facebookCreativeIds,
        connectedFeed: connectedFeed,
        connectedFeedName: connectedFeedName,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: filteredFontList,
        creatives: creativeRes.payload,
        uploadLimits: uploadLimits,
        title: title
      }));
      toast.success(language[response.code], { autoClose: 3000 });
      dispatch(setCampaignLoader(false));
      return response;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    dispatch(setCampaignLoader(false));
    return error;
  }
}

export const duplicateCreativeWithResize = (id, width, height) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const {
      currentCampaign,
      versions,
      currentVersion,
      facebookId,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds,
      connectedFeed,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      creatives,
      scrolledCreatives,
      uploadLimits
    } = getState().Campaign;
    const contentId = getState().Campaign.id;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brand: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    }
    if (contentId?.value && contentId.value.trim() !== '') {
      facebookProperties.properties.id = contentId;
    }
    const { title } = getState().MenuData;
    dispatch(setCampaignLoader(true));
    const response = await postCreativeSize({
      creativeId: id,
      width: String(width),
      height: String(height)
    });
    if (response.status === 'ok') {
      const creativeRes = await dispatch(getCreatives(currentVersion._id));
      // await dispatch(setCreativeFigmaBeforePreview());
      dispatch(setScrolledCreatives([...scrolledCreatives, creativeRes.payload.find(creative => creative._id === response.data.insertedIds['0'])]));
      dispatch(replace(window.location.href, {
        currentCampaign: currentCampaign,
        versions: versions,
        currentVersion: currentVersion,
        facebookProperties: facebookProperties,
        isFacebookPropertiesSet: isFacebookPropertiesSet,
        facebookStatus: facebookStatus,
        facebookCreativeIds: facebookCreativeIds,
        connectedFeed: connectedFeed,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: filteredFontList,
        creatives: [...scrolledCreatives, creativeRes.payload.find(creative => creative._id === response.data.insertedIds['0'])],
        uploadLimits: uploadLimits,
        title: title
      }));
      dispatch(toggleDuplicateNewSizeCreativeModal())
      toast.success(language[response.code], { autoClose: 3000 });
      dispatch(updateVersionStatusAfterUpdate());
      dispatch(setCampaignLoader(false));
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
    // console.log(error);
    dispatch(setCampaignLoader(false));
  }
}

export const saveFallbackImage = (data) => async (dispatch, getState) => {
  // try {
  //   const id = getState().Campaign.selectedCreative._id;

  //   const uploadImageResponse = await dispatch(sendUploadFiles(data));
  //   // Upload File
  //   let response = await putCreative({ id: id, fallback: uploadImageResponse });

  // } catch (error) {

  // }
}

export const saveFallbackImageAllSizes = (data) => async (dispatch, getState) => {
  // try {
  //   const filteredCreatives = getState().Campaign.filteredCreatives;
  //   let i = 0;
  //   do {
  //     const uploadImageResponse = await dispatch(sendUploadFiles(data));
  //     let response = await putCreative({ id: filteredCreatives[i]._id, fallback: uploadImageResponse });

  //     i++;
  //   } while (i < filteredCreatives.length);
  // } catch (error) {

  // }
}

export const removeCreative = (id) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const {
      currentCampaign,
      versions,
      currentVersion,
      facebookId,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds,
      connectedFeed,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      creatives,
      uploadLimits,
    } = getState().Campaign;
    const contentId = getState().Campaign.id;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brand: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    }
    if (contentId?.value && contentId.value.trim() !== '') {
      facebookProperties.properties.id = contentId;
    }
    const { title } = getState().MenuData;
    const response = await deleteCreative({ id: id });

    if (response.status === 'ok') {
      // dispatch(getCreatives(currentVersion._id));
      dispatch(replace(window.location.href, {
        currentCampaign: currentCampaign,
        versions: versions,
        currentVersion: currentVersion,
        facebookProperties: facebookProperties,
        isFacebookPropertiesSet: isFacebookPropertiesSet,
        facebookStatus: facebookStatus,
        facebookCreativeIds: facebookCreativeIds,
        connectedFeed: connectedFeed,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: filteredFontList,
        creatives: creatives.filter(item => item._id !== id).map(item => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          return returnObj;
        }),
        uploadLimits: uploadLimits,
        title: title
      }));
      return true;
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
};

// Comments
export const getComments = (data) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const response = await getCommentsData(data);

    if (response.status === 'ok') {
      dispatch(setComments(response.data));
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const sendComment = (data) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const userId = getState().Login.user.data.userId;
    const versionId = getState().MenuData.versionPath;
    const { comments, versions, creatives } = getState().Campaign;
    const response = await postComment(data);

    if (response.status === "ok") {
      dispatch(setComments([...comments, { ...data, _id: response.data.insertedId, userId: userId }]));
      if (data.type === 'creative') {
        dispatch(setCreativeCommentCount(data.relationId));
      }
    } else {
      throw response
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

// Template
export const getTemplate = createAsyncThunk("campaigns/getTemplatesData", async (data, { dispatch, getState }) => {
  try {
    const { brandPath, marketPath } = getState().MenuData;
    const { currentCampaign } = getState().Campaign;
    const templateFilter = getState().Campaign.templateFilter;
    let response = await getTemplateData({ ...templateFilter, brandId: brandPath, marketId: marketPath, adType: currentCampaign.adType });
    return response.data;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const createTemplate = () => async (dispatch, getState) => {
  try {
    const { brandPath } = getState().MenuData;
    const { currentCampaign, templateName } = getState().Campaign;
    const { uploadedFiles } = getState().Upload;

    const uploadRes = await dispatch(sendUploadFiles(uploadedFiles.map(item => item.zip)));

    if (uploadRes) {
      const templateRes = await postTemplate({
        name: templateName,
        thumbnail: uploadedFiles[0].preview,
        brandId: brandPath,
        categoryId: "66a37211d15a5db78adb83b0",
        sizes: uploadedFiles.map(item => item.pixelSize),
        dynamicAreas: uploadRes[0][0].dynamicInputs,
        // type: currentCampaign.adType,
        type: null,
        campaignId: currentCampaign._id,
      });
      if (templateRes.status === 'ok') {
        const creativeRes = await dispatch(createTemplateCreative(templateRes.data.insertedId, uploadedFiles, uploadRes));
        if (creativeRes.status === 'ok') {
          dispatch(setSelectedTemplate({
            _id: templateRes.data.insertedId,
            name: templateName,
            thumbnail: uploadedFiles[0].preview,
            categoryId: "66a37211d15a5db78adb83b0",
            sizes: uploadedFiles.map(item => item.pixelSize),
            brandId: brandPath,
            dynamicAreas: uploadRes[0][0].dynamicInputs,
            type: null,
            status: true
          }));
          dispatch(setDynamicText(uploadRes[0][0].dynamicInputs));
          const templateCreativeRes = await dispatch(getTemplateCreatives(templateRes.data.insertedId));
          dispatch(setUploadedFiles(templateCreativeRes.payload));
          dispatch(setFilteredTemplateCreatives(templateCreativeRes.payload));
        }
      }
    };
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const createTemplateCreative = (templateId, uploadedFiles, uploadedCreatives) => async (dispatch, getState) => {
  try {
    const res = await postTemplateCreatives({
      creatives: uploadedCreatives[0].map(item => item.path),
      templateId: templateId,
      sizes: uploadedFiles.map(item => item.pixelSize),
      fileSizes: uploadedFiles.map(item => item.formattedSize),
      figma: uploadedFiles.map(item => item.figma)
    });
    return res;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const getTemplateCategory = createAsyncThunk('campaigns/getTemplateCategoryData', async (data, { dispatch, getState }) => {
  try {
    const templates = getState().Campaign.templates;
    const categories = [];
    // let i = 0;
    // do {
    // let template = templates[i];
    let response = await getCategoriesData({ id: templates[0].categoryId });
    if (categories.some(el => el.categoryId !== response.data[0]._id) === false) {
      categories.push(response.data[0]);
    }
    //   i++;
    // } while (i < templates.length);

    return categories;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const getTemplateCreatives = createAsyncThunk("campaigns/getTemplateCreativesData", async (id, { dispatch, getState }) => {
  try {
    const { marketPath } = getState().MenuData;
    let response = await getTemplateCreativesData({ id: id, marketId: marketPath });
    let data = [];
    let i = 0;
    do {
      const tCreative = response.data[i];
      let figmaObj = await getFigmaObj(tCreative.figma);
      const fonts = await dispatch(loadFonts(figmaObj));
      figmaObj.node.googlefont.style = fonts;
      figmaObj.node.adcfont.style = fonts;
      let tCreativeObj = {
        ...tCreative,
        figmaObject: figmaObj,
        pixelSize: tCreative.size
      };
      const previewRes = await dispatch(createPreview(tCreativeObj));
      tCreativeObj.templatePreview = previewRes.preview;
      data.push(tCreativeObj);
      i++;
    } while (i < response.data.length);
    data = sortByWidth(data, 'size');
    return data;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log('error', error);
  }
});


export const addTemplateCreative = () => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const {
      currentCampaign,
      versions,
      currentVersion,
      connectedFeed,
      isFacebookPropertiesSet,
      facebookStatus,
      facebookCreativeIds,
      dynamicText,
      activeDynamicText,
      filteredFontList,
      facebookId,
      creatives,
      scrolledCreatives,
      uploadLimits,
    } = getState().Campaign;
    const contentId = getState().Campaign.id;
    const facebookProperties = {
      _id: facebookId,
      properties: {
        title: getState().Campaign.title,
        description: getState().Campaign.description,
        availability: getState().Campaign.availability,
        condition: getState().Campaign.condition,
        price: getState().Campaign.price,
        link: getState().Campaign.link,
        image_link: getState().Campaign.image_link,
      },
      brand: getState().Campaign.brand,
      interval: getState().Campaign.interval,
      exportType: 'image',
      limit: getState().Campaign.limit
    }
    if (contentId?.value && contentId.value.trim() !== '') {
      facebookProperties.properties.id = contentId;
    }
    const { title } = getState().MenuData;
    const uploadedFiles = getState().Upload.uploadedFiles;
    // Create Creative
    if (uploadedFiles.length > 0) {
      const createCreativeResponse = await dispatch(createCreative({
        versionId: currentVersion._id,
        campaignId: currentCampaign._id,
        creatives: uploadedFiles.map(item => item.path),
        sizes: uploadedFiles.map(item => item.pixelSize),
        fileSizes: uploadedFiles.map(item => item.fileSize),
        figmaObjects: uploadedFiles.map(item => item.figmaObject)
      }));
      if (createCreativeResponse.status === 'ok') {
        // dispatch(openCampaign(currentCampaign))
        const getCreativesRes = await dispatch(getCreatives(currentVersion._id));
        // await dispatch(setCreativeFigmaBeforePreview());
        const insertedIds = Object.values(createCreativeResponse.data.insertedIds);
        const insertedCreatives = filterCreativesByIdArray(getCreativesRes.payload, insertedIds);
        const updatedCreatives = [...scrolledCreatives, ...insertedCreatives];
        dispatch(setScrolledCreatives(updatedCreatives));
        dispatch(replace(window.location.href, {
          currentCampaign: currentCampaign,
          versions: versions,
          currentVersion: currentVersion,
          facebookProperties: facebookProperties,
          isFacebookPropertiesSet: isFacebookPropertiesSet,
          facebookStatus: facebookStatus,
          facebookCreativeIds: facebookCreativeIds,
          facebookId: facebookId,
          connectedFeed: connectedFeed,
          dynamicText: dynamicText,
          activeDynamicText: activeDynamicText,
          fontRes: filteredFontList,
          creatives: updatedCreatives,
          uploadLimits: uploadLimits,
          title: title
        }));
      } else {
        throw createCreativeResponse;
      }
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const createDynamicText = (data) => async (dispatch, getState) => {
  try {
    let response = await postDynamicText({
      versionId: data.versionId,
      campaignId: data.campaignId,
      texts: data.texts,
      creativeId: data.creativeId
    })
    return response;

  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const getDynamicText = createAsyncThunk("dynamictext/getDynamicText", async (data, { dispatch, getState }) => {
  try {
    const response = await getDynamicTextData({
      versionId: data.versionId,
      creativeId: data.creativeId,
      preview: true
    });
    // const dynamicTexts = [];
    // if (response.data.length > 0) {
    //   let i = 0;
    //   do {
    //     let dynamicTextObj = response.data[i];
    //     dynamicTextObj.texts = sortAlphabetically(dynamicTextObj.texts, 'name');
    //     dynamicTexts.push(dynamicTextObj);
    //     i++;
    //   } while (i < response.data.length);
    // }
    // return dynamicTexts;
    if (response.data.length > 0) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
})

// export const setDynamicTextTag = (data) => async (dispatch, getState) => {
//   try {
//     const { dynamicText, activeDynamicText } = getState().Campaign;
//     const newDynamicTexts = [];
//     if (activeDynamicText?.isCreative === false) {
//       let i = 0;
//       do {
//         if (dynamicText[0].texts[i].tag === data.tag) {
//           const updatedTextObj = {
//             ...dynamicText[0].texts[i],
//             value: data.value,
//             isFeed: data.isFeed
//           };
//           if (data?.file) {
//             updatedTextObj.file = data.file;
//           }
//           if (data?.style) {
//             updatedTextObj.style = data.style;
//           }
//           if (data?.poster) {
//             updatedTextObj.poster = data.poster;
//             updatedTextObj.posterFile = data.posterFile;
//           }
//           newDynamicTexts.push(updatedTextObj);
//         } else {
//           newDynamicTexts.push({ ...dynamicText[0].texts[i] })
//         }
//         i++;
//       } while (i < dynamicText[0].texts.length);
//       let otherDynamicTexts = [];
//       if (dynamicText.length > 1) {
//         otherDynamicTexts = dynamicText.slice(1, dynamicText.length);
//       }
//       dispatch(setDynamicText([{ ...dynamicText[0], texts: newDynamicTexts }, ...otherDynamicTexts]));
//     } else if (activeDynamicText?.isCreative === true) {
//       const foundCreativeDynamicText = dynamicText.find(item => item.creativeId === activeDynamicText.creativeId);
//       if (foundCreativeDynamicText) {
//         let i = 0;
//         do {
//           if (foundCreativeDynamicText.texts[i].tag === data.tag) {
//             const updatedTextObj = { ...foundCreativeDynamicText.texts[i], value: data.value, isFeed: data.isFeed };
//             if (data?.file) {
//               updatedTextObj.file = data.file;
//             }
//             if (data?.path) {
//               updatedTextObj.path = data.path;
//             }
//             if (data?.style) {
//               updatedTextObj.style = data.style;
//             }
//             if (data?.poster) {
//               updatedTextObj.poster = data.poster;
//               updatedTextObj.posterFile = data.posterFile;
//             }
//             newDynamicTexts.push(updatedTextObj);
//           } else {
//             newDynamicTexts.push({ ...foundCreativeDynamicText.texts[i] })
//           }
//           i++;
//         } while (i < foundCreativeDynamicText.texts.length);
//         const filteredCreativeDynamicText = dynamicText.filter(item => item.creativeId !== activeDynamicText.creativeId);
//         dispatch(setDynamicText([...filteredCreativeDynamicText, { ...foundCreativeDynamicText, texts: newDynamicTexts }]));
//       }
//     }
//     dispatch(setActiveDynamicText({ ...activeDynamicText, texts: newDynamicTexts }));
//     return { ...activeDynamicText, texts: newDynamicTexts };
//   } catch (error) {

//   }
// };

export const setDynamicTextTag = (item) => async (dispatch, getState) => {
  try {
    const { dynamicText, activeDynamicText, selectedCreative } = getState().Campaign;
    if (activeDynamicText.isCreative === false && !selectedCreative) {
      if (item.dynamicTextIdx === 0 && item.dynamicTextIdxs.length === dynamicText.length) {
        let i = 0;
        const updatedDynamicText = [];
        do {
          const newDynamicTexts = [];
          let k = 0;
          do {
            if (dynamicText[item.dynamicTextIdxs[i]].texts[k].tag === item.tag) {
              let updatedTextObj = {
                ...dynamicText[item.dynamicTextIdxs[i]].texts[k],
                value: item.value,
                isFeed: item.isFeed,
                feedName: item.feedName
              };
              if (item?.file) {
                updatedTextObj.file = item.file;
              }
              updatedTextObj.value = item.value;
              if (item?.poster) {
                updatedTextObj.poster = item.poster;
              }
              if (item?.posterFile) {
                updatedTextObj.posterFile = item.posterFile;
              }
              if (item.hasOwnProperty('backgroundStatus')) {
                updatedTextObj.backgroundStatus = item.backgroundStatus;
              }
              newDynamicTexts.push(updatedTextObj);
            } else {
              newDynamicTexts.push({ ...dynamicText[item.dynamicTextIdxs[i]].texts[k] })
            }
            k++;
          } while (k < dynamicText[item.dynamicTextIdxs[i]].texts.length);
          updatedDynamicText.push({ ...dynamicText[item.dynamicTextIdxs[i]], texts: newDynamicTexts });
          i++;
        } while (i < item.dynamicTextIdxs.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      } else {
        const updatedDynamicText = [];
        let i = 0;
        do {
          const newDynamicTexts = [];
          if (item.dynamicTextIdxs.includes(i)) {
            let k = 0;
            do {
              if (dynamicText[i].texts[k].tag === item.tag) {
                let updatedTextObj = { ...dynamicText[i].texts[k], value: item.value, isFeed: item.isFeed, feedName: item.feedName };
                if (item?.file) {
                  updatedTextObj.file = item.file;
                }
                updatedTextObj.value = item.value;
                if (item?.path) {
                  updatedTextObj.path = item.path;
                }
                if (item?.poster) {
                  updatedTextObj.poster = item.poster;
                }
                if (item?.posterFile) {
                  updatedTextObj.posterFile = item.posterFile;
                }
                if (item.hasOwnProperty('backgroundStatus')) {
                  updatedTextObj.backgroundStatus = item.backgroundStatus;
                }
                newDynamicTexts.push(updatedTextObj);
              } else {
                newDynamicTexts.push({ ...dynamicText[i].texts[k] })
              }
              k++;
            } while (k < dynamicText[i].texts.length);
            updatedDynamicText.push({ ...dynamicText[i], texts: newDynamicTexts });
          } else {
            updatedDynamicText.push({ ...dynamicText[i] });
          }
          i++;
        } while (i < dynamicText.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      }
    } else if (activeDynamicText?.isCreative === true) {
      const newDynamicTexts = [];
      let foundCreativeDynamicText = dynamicText.find(dItem => dItem.creativeId === activeDynamicText.creativeId);
      if (foundCreativeDynamicText) {
        let i = 0;
        do {
          if (foundCreativeDynamicText.texts[i].tag === item.tag) {
            const updatedTextObj = { ...foundCreativeDynamicText.texts[i], value: item.value, isFeed: item.isFeed, feedName: item.feedName };
            if (item?.file) {
              updatedTextObj.file = item.file;
            }
            updatedTextObj.value = item.value;
            if (item?.path) {
              updatedTextObj.path = item.path;
            }
            if (item?.poster) {
              updatedTextObj.poster = item.poster;
              updatedTextObj.posterFile = item.posterFile;
            }
            if (item.hasOwnProperty('backgroundStatus')) {
              updatedTextObj.backgroundStatus = item.backgroundStatus;
            }
            newDynamicTexts.push(updatedTextObj);
          } else {
            newDynamicTexts.push({ ...foundCreativeDynamicText.texts[i] })
          }
          i++;
        } while (i < foundCreativeDynamicText.texts.length);
        const filteredCreativeDynamicText = dynamicText.filter(dItem => dItem.creativeId !== activeDynamicText.creativeId);
        dispatch(setDynamicText([...filteredCreativeDynamicText, { ...foundCreativeDynamicText, texts: newDynamicTexts }]));
        return { ...foundCreativeDynamicText, texts: newDynamicTexts };
      }
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const removeVideoDynamicTextTag = (item) => async (dispatch, getState) => {
  try {
    const { dynamicText, activeDynamicText, selectedCreative } = getState().Campaign;
    if (activeDynamicText.isCreative === false && !selectedCreative) {
      if (item.dynamicTextIdx === 0 && item.dynamicTextIdxs.length === dynamicText.length) {
        let i = 0;
        const updatedDynamicText = [];
        do {
          const newDynamicTexts = [];
          let k = 0;
          do {
            if (dynamicText[item.dynamicTextIdxs[i]].texts[k].tag === item.tag) {
              const keys = Object.keys(foundCreativeDynamicText.texts[i]);
              const updatedTextObj = {};
              keys.forEach(key => {
                if (key === 'value') {
                  updatedTextObj[key] = '';
                } else if (key !== 'file') {
                  updatedTextObj[key] = foundCreativeDynamicText.texts[i][key];
                }
              });
              newDynamicTexts.push(updatedTextObj);
            } else {
              newDynamicTexts.push({ ...dynamicText[item.dynamicTextIdxs[i]].texts[k] })
            }
            k++;
          } while (k < dynamicText[item.dynamicTextIdxs[i]].texts.length);
          updatedDynamicText.push({ ...dynamicText[item.dynamicTextIdxs[i]], texts: newDynamicTexts });
          i++;
        } while (i < item.dynamicTextIdxs.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      } else {
        const updatedDynamicText = [];
        let i = 0;
        do {
          const newDynamicTexts = [];
          if (item.dynamicTextIdxs.includes(i)) {
            let k = 0;
            do {
              if (dynamicText[i].texts[k].tag === item.tag) {
                const keys = Object.keys(foundCreativeDynamicText.texts[i]);
                const updatedTextObj = {};
                keys.forEach(key => {
                  if (key === 'value') {
                    updatedTextObj[key] = '';
                  } else if (key !== 'file') {
                    updatedTextObj[key] = foundCreativeDynamicText.texts[i][key];
                  }
                });
                newDynamicTexts.push(updatedTextObj);
              } else {
                newDynamicTexts.push({ ...dynamicText[i].texts[k] })
              }
              k++;
            } while (k < dynamicText[i].texts.length);
            updatedDynamicText.push({ ...dynamicText[i], texts: newDynamicTexts });
          } else {
            updatedDynamicText.push({ ...dynamicText[i] });
          }
          i++;
        } while (i < dynamicText.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      }
    } else if (activeDynamicText?.isCreative === true) {
      const newDynamicTexts = [];
      let foundCreativeDynamicText = dynamicText.find(dItem => dItem.creativeId === activeDynamicText.creativeId);
      if (foundCreativeDynamicText) {
        let i = 0;
        do {
          if (foundCreativeDynamicText.texts[i].tag === item.tag) {
            const keys = Object.keys(foundCreativeDynamicText.texts[i]);
            const updatedTextObj = {};
            keys.forEach(key => {
              if (key === 'value') {
                updatedTextObj[key] = '';
              } else if (key !== 'file') {
                updatedTextObj[key] = foundCreativeDynamicText.texts[i][key];
              }
            });
            newDynamicTexts.push(updatedTextObj);
          } else {
            newDynamicTexts.push({ ...foundCreativeDynamicText.texts[i] })
          }
          i++;
        } while (i < foundCreativeDynamicText.texts.length);
        const filteredCreativeDynamicText = dynamicText.filter(dItem => dItem.creativeId !== activeDynamicText.creativeId);
        dispatch(setDynamicText([...filteredCreativeDynamicText, { ...foundCreativeDynamicText, texts: newDynamicTexts }]));
        return { ...foundCreativeDynamicText, texts: newDynamicTexts };
      }
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
};

export const removePosterDynamicTextTag = (item) => async (dispatch, getState) => {
  try {
    const { dynamicText, activeDynamicText, selectedCreative } = getState().Campaign;
    if (activeDynamicText.isCreative === false && !selectedCreative) {
      if (item.dynamicTextIdx === 0 && item.dynamicTextIdxs.length === dynamicText.length) {
        let i = 0;
        const updatedDynamicText = [];
        do {
          const newDynamicTexts = [];
          let k = 0;
          do {
            if (dynamicText[item.dynamicTextIdxs[i]].texts[k].tag === item.tag) {
              const keys = Object.keys(foundCreativeDynamicText.texts[i]);
              const updatedTextObj = {};
              keys.forEach(key => {
                if (key === 'poster') {
                  updatedTextObj[key] = '';
                } else if (key !== 'posterFile') {
                  updatedTextObj[key] = foundCreativeDynamicText.texts[i][key];
                }
              });
              newDynamicTexts.push(updatedTextObj);
            } else {
              newDynamicTexts.push({ ...dynamicText[item.dynamicTextIdxs[i]].texts[k] })
            }
            k++;
          } while (k < dynamicText[item.dynamicTextIdxs[i]].texts.length);
          updatedDynamicText.push({ ...dynamicText[item.dynamicTextIdxs[i]], texts: newDynamicTexts });
          i++;
        } while (i < item.dynamicTextIdxs.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      } else {
        const updatedDynamicText = [];
        let i = 0;
        do {
          const newDynamicTexts = [];
          if (item.dynamicTextIdxs.includes(i)) {
            let k = 0;
            do {
              if (dynamicText[i].texts[k].tag === item.tag) {
                const keys = Object.keys(foundCreativeDynamicText.texts[i]);
                const updatedTextObj = {};
                keys.forEach(key => {
                  if (key === 'poster') {
                    updatedTextObj[key] = '';
                  } else if (key !== 'posterFile') {
                    updatedTextObj[key] = foundCreativeDynamicText.texts[i][key];
                  }
                });
                newDynamicTexts.push(updatedTextObj);
              } else {
                newDynamicTexts.push({ ...dynamicText[i].texts[k] })
              }
              k++;
            } while (k < dynamicText[i].texts.length);
            updatedDynamicText.push({ ...dynamicText[i], texts: newDynamicTexts });
          } else {
            updatedDynamicText.push({ ...dynamicText[i] });
          }
          i++;
        } while (i < dynamicText.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      }
    } else if (activeDynamicText?.isCreative === true) {
      const newDynamicTexts = [];
      let foundCreativeDynamicText = dynamicText.find(dItem => dItem.creativeId === activeDynamicText.creativeId);
      if (foundCreativeDynamicText) {
        let i = 0;
        do {
          if (foundCreativeDynamicText.texts[i].tag === item.tag) {
            const keys = Object.keys(foundCreativeDynamicText.texts[i]);
            const updatedTextObj = {};
            keys.forEach(key => {
              if (key === 'poster') {
                updatedTextObj[key] = '';
              } else if (key !== 'posterFile') {
                updatedTextObj[key] = foundCreativeDynamicText.texts[i][key];
              }
            });
            newDynamicTexts.push(updatedTextObj);
          } else {
            newDynamicTexts.push({ ...foundCreativeDynamicText.texts[i] })
          }
          i++;
        } while (i < foundCreativeDynamicText.texts.length);
        const filteredCreativeDynamicText = dynamicText.filter(dItem => dItem.creativeId !== activeDynamicText.creativeId);
        dispatch(setDynamicText([...filteredCreativeDynamicText, { ...foundCreativeDynamicText, texts: newDynamicTexts }]));
        return { ...foundCreativeDynamicText, texts: newDynamicTexts };
      }
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

// export const setDynamicTextTargetUrl = (data) => async (dispatch, getState) => {
//   try {
//     const { dynamicText, activeDynamicText } = getState().Campaign;
//     const newDynamicTexts = [];
//     if (activeDynamicText?.isCreative === false) {
//       let i = 0;
//       do {
//         if (dynamicText[0].texts[i].tag === data.tag) {
//           const updatedTextObj = {
//             ...dynamicText[0].texts[i],
//             targetUrl: data.targetUrl
//           };
//           if (data?.file) {
//             updatedTextObj.file = data.file;
//           }
//           if (data?.style) {
//             updatedTextObj.style = data.style;
//           }
//           newDynamicTexts.push(updatedTextObj);
//         } else {
//           newDynamicTexts.push({ ...dynamicText[0].texts[i] })
//         }
//         i++;
//       } while (i < dynamicText[0].texts.length);
//       let otherDynamicTexts = [];
//       if (dynamicText.length > 1) {
//         otherDynamicTexts = dynamicText.slice(1, dynamicText.length);
//       }
//       dispatch(setDynamicText([{ ...dynamicText[0], texts: newDynamicTexts }, ...otherDynamicTexts]));
//     } else if (activeDynamicText?.isCreative === true) {
//       const foundCreativeDynamicText = dynamicText.find(item => item.creativeId === activeDynamicText.creativeId);
//       if (foundCreativeDynamicText) {
//         let i = 0;
//         do {
//           if (foundCreativeDynamicText.texts[i].tag === data.tag) {
//             const updatedTextObj = { ...foundCreativeDynamicText.texts[i], targetUrl: data.targetUrl };
//             if (data?.file) {
//               updatedTextObj.file = data.file;
//             }
//             if (data?.path) {
//               updatedTextObj.path = data.path;
//             }
//             if (data?.style) {
//               updatedTextObj.style = data.style;
//             }
//             newDynamicTexts.push(updatedTextObj);
//           } else {
//             newDynamicTexts.push({ ...foundCreativeDynamicText.texts[i] })
//           }
//           i++;
//         } while (i < foundCreativeDynamicText.texts.length);
//         const filteredCreativeDynamicText = dynamicText.filter(item => item.creativeId !== activeDynamicText.creativeId);
//         dispatch(setDynamicText([...filteredCreativeDynamicText, { ...foundCreativeDynamicText, texts: newDynamicTexts }]));
//       }
//     }
//     dispatch(setActiveDynamicText({ ...activeDynamicText, texts: newDynamicTexts }));
//     return { ...activeDynamicText, texts: newDynamicTexts };
//   } catch (error) {

//   }
// }


export const setDynamicTextTargetUrl = (item) => async (dispatch, getState) => {
  try {
    const { dynamicText, activeDynamicText, selectedCreative } = getState().Campaign;
    if (activeDynamicText.isCreative === false && !selectedCreative) {
      if (item.dynamicTextIdx === 0 && item.dynamicTextIdxs.length === dynamicText.length) {
        let i = 0;
        const updatedDynamicText = [];
        do {
          const newDynamicTexts = [];
          let k = 0;
          do {
            if (dynamicText[item.dynamicTextIdxs[i]].texts[k].tag === item.tag) {
              let updatedTextObj = {
                ...dynamicText[item.dynamicTextIdxs[i]].texts[k],
                targetUrl: item.targetUrl
              };
              if (item?.file) {
                updatedTextObj.file = item.file;
              }
              if (item?.style) {
                updatedTextObj.style = item.style;
              }
              if (item?.poster) {
                updatedTextObj.poster = item.poster;
                updatedTextObj.posterFile = item.posterFile;
              }
              newDynamicTexts.push(updatedTextObj);
            } else {
              newDynamicTexts.push({ ...dynamicText[item.dynamicTextIdxs[i]].texts[k] })
            }
            k++;
          } while (k < dynamicText[item.dynamicTextIdxs[i]].texts.length);
          updatedDynamicText.push({ ...dynamicText[item.dynamicTextIdxs[i]], texts: newDynamicTexts });
          i++;
        } while (i < item.dynamicTextIdxs.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      } else {
        const updatedDynamicText = [];
        let i = 0;
        do {
          const newDynamicTexts = [];
          if (item.dynamicTextIdxs.includes(i)) {
            let k = 0;
            do {
              if (dynamicText[i].texts[k].tag === item.tag) {
                let updatedTextObj = { ...dynamicText[i].texts[k], targetUrl: item.targetUrl };
                if (item?.file) {
                  updatedTextObj.file = item.file;
                }
                if (item?.path) {
                  updatedTextObj.path = item.path;
                }
                if (item?.style) {
                  updatedTextObj.style = item.style;
                }
                if (item?.poster) {
                  updatedTextObj.poster = item.poster;
                  updatedTextObj.posterFile = item.posterFile;
                }
                newDynamicTexts.push(updatedTextObj);
              } else {
                newDynamicTexts.push({ ...dynamicText[i].texts[k] })
              }
              k++;
            } while (k < dynamicText[i].texts.length);
            updatedDynamicText.push({ ...dynamicText[i], texts: newDynamicTexts });
          } else {
            updatedDynamicText.push({ ...dynamicText[i] });
          }
          i++;
        } while (i < dynamicText.length);
        dispatch(setDynamicText(updatedDynamicText));
        return { ...updatedDynamicText[0] }
      }
    } else if (activeDynamicText?.isCreative === true) {
      const newDynamicTexts = [];
      let foundCreativeDynamicText = dynamicText.find(dItem => dItem.creativeId === activeDynamicText.creativeId);
      if (foundCreativeDynamicText) {
        let i = 0;
        do {
          if (foundCreativeDynamicText.texts[i].tag === item.tag) {
            const updatedTextObj = { ...foundCreativeDynamicText.texts[i], targetUrl: item.targetUrl };
            if (item?.file) {
              updatedTextObj.file = item.file;
            }
            if (item?.path) {
              updatedTextObj.path = item.path;
            }
            if (item?.style) {
              updatedTextObj.style = item.style;
            }
            if (item?.poster) {
              updatedTextObj.poster = item.poster;
              updatedTextObj.posterFile = item.posterFile;
            }
            newDynamicTexts.push(updatedTextObj);
          } else {
            newDynamicTexts.push({ ...foundCreativeDynamicText.texts[i] })
          }
          i++;
        } while (i < foundCreativeDynamicText.texts.length);
        const filteredCreativeDynamicText = dynamicText.filter(dItem => dItem.creativeId !== activeDynamicText.creativeId);
        dispatch(setDynamicText([...filteredCreativeDynamicText, { ...foundCreativeDynamicText, texts: newDynamicTexts }]));
        return { ...foundCreativeDynamicText, texts: newDynamicTexts };
      }
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const setCreativeFigmaBeforePreview = () => async (dispatch, getState) => {
  try {
    return new Promise((resolve, reject) => {
      const { dynamicText, creatives, activeDynamicText } = getState().Campaign;
      if (Array.isArray(dynamicText) && dynamicText.length === 1) {
        dispatch(setActiveDynamicText(dynamicText[0]));
        const creativeIds = creatives.filter(item => item.versionId === dynamicText[0].versionId);
        dispatch(updateCreativeFigmaAfterDynamicText({
          creativeIds: creativeIds.map(item => item._id),
          activeDynamicText: dynamicText[0]
        }));
      } else if (Array.isArray(dynamicText) && dynamicText.length > 1) {
        const creativeDynamicTexts = dynamicText.slice(0, dynamicText.length);
        let i = 0;
        do {
          dispatch(setActiveDynamicText(creativeDynamicTexts[i]));
          let creativeIds = [];
          if (creativeDynamicTexts[i].isCreative === false) {
            creativeIds = creatives.filter(item => {
              if (item.versionId === creativeDynamicTexts[i].versionId) {
                return item;
              }
            });
          } else if (creativeDynamicTexts[i].isCreative === true) {
            creativeIds = creatives.filter(item => {
              if (item._id === creativeDynamicTexts[i].creativeId) {
                return item;
              }
            });
          }
          if (creativeIds.length > 0) {
            dispatch(updateCreativeFigmaAfterDynamicText({
              creativeIds: creativeIds.map(item => item._id),
              activeDynamicText: creativeDynamicTexts[i]
            }));
          }
          i++;
        } while (i < creativeDynamicTexts.length);
        dispatch(setActiveDynamicText(dynamicText[0]));
      }
      resolve(true);
    })
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}


// export const setCreativesDynamicText = () => async (dispatch, getState) => {
//   try {
//     const { currentVersion, creatives, filteredCreatives, dynamicText, activeDynamicText, connectedFeed } = getState().Campaign;
//     const { preview } = getState().Feed;
//     let dTexts;
//     if (currentVersion.hasOwnProperty('feeds') && Array.isArray(currentVersion.feeds)) {
//       dTexts = setConnectedFeedValueBeforePreview(activeDynamicText, connectedFeed);
//     } else {
//       dTexts = activeDynamicText.texts;
//     }
//     if (activeDynamicText.isCreative === false) {
//       let filteredDynamicCreatives = filteredCreatives;
//       if (dynamicText.length > 1) {
//         const creativeDynamicTexts = dynamicText.slice(1, dynamicText.length);
//         filteredDynamicCreatives = filteredCreatives.filter(creative => {
//           if (!creativeDynamicTexts.some(cDynamicText => creative._id === cDynamicText.creativeId)) {
//             return creative;
//           }
//         });
//       }
//       let i = 0;
//       do {
//         if (filteredDynamicCreatives[i].preview.contentWindow) {
//           filteredDynamicCreatives[i].preview.contentWindow.postMessage({
//             action: "adc-set-dynamic-text-elements",
//             texts: dTexts
//           }, "*");
//         }
//         i++;
//       } while (i < filteredDynamicCreatives.length);
//       dispatch(updateCreativeFigmaAfterDynamicText({
//         creativeIds: filteredDynamicCreatives.map(item => item._id),
//         activeDynamicText: activeDynamicText
//       }));
//     } else if (activeDynamicText.isCreative === true) {
//       const foundCreative = filteredCreatives.find(item => item._id === activeDynamicText.creativeId);
//       if (foundCreative && foundCreative.preview.contentWindow) {
//         foundCreative.preview.contentWindow.postMessage({
//           action: "adc-set-dynamic-text-elements",
//           texts: dTexts
//         }, "*");
//         dispatch(updateCreativeFigmaAfterDynamicText({
//           creativeIds: [foundCreative._id],
//           activeDynamicText: activeDynamicText
//         }));
//       }
//     }
//   } catch (error) {

//   }
// };

export const setCreativesDynamicText = (item) => async (dispatch, getState) => {
  try {
    const { currentVersion, creatives, filteredCreatives, scrolledCreatives, dynamicText, activeDynamicText, connectedFeed } = getState().Campaign;
    let i = 0;
    do {
      let dTexts;
      if (currentVersion.hasOwnProperty('feeds') && Array.isArray(currentVersion.feeds) && connectedFeed) {
        dTexts = setConnectedFeedValueBeforePreview(dynamicText[i], connectedFeed);
      } else {
        dTexts = dynamicText[i].texts;
      }
      let creativesArr = creatives;
      if (dynamicText[i].isCreative) {
        const foundCreative = creatives.find(creative => creative._id === dynamicText[i].creativeId);
        if (foundCreative) {
          creativesArr = [foundCreative];
        } else {
          creativesArr = [];
        }
      }
      if (creativesArr.length) {
        let k = 0;
        do {
          if (creativesArr[k].preview && creativesArr[k].preview.contentWindow) {
            creativesArr[k].preview.contentWindow.postMessage({
              action: "adc-set-dynamic-text-elements",
              texts: dTexts
            }, "*");
          }
          dispatch(updateCreativeFigmaAfterDynamicText({
            creativeIds: [creativesArr[k]._id],
            activeDynamicText: dynamicText[i]
          }));
          k++;
        } while (k < creativesArr.length);
      }
      i++;
    } while (i < dynamicText.length);

  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const updatePreviewWhenImageToggled = (creativeObj) => async (dispatch, getState) => {
  try {
    const { creatives } = getState().Campaign;
    const foundCreative = creatives.find(item => item._id === creativeObj.creativeId);

    if (foundCreative) {
      foundCreative.preview.contentWindow.postMessage({
        action: 'adc-image-toggled',
        isVisible: creativeObj.isVisible,
        tag: creativeObj.tag
      }, '*');
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const setAllCreativesFont = () => async (dispatch, getState) => {
  try {
    const { creatives, filteredCreatives, dynamicText, activeDynamicText } = getState().Campaign;
    let i = 0;
    do {
      const fonts = getFontNamesFromDynamicText(dynamicText);
      let fontCss = '';
      if (fonts.length > 0) {
        let l = 0
        do {
          fontCss += `${fonts[l].name.replaceAll(' ', '+')}:${fonts[l].style}:${fonts[l].weight}||`;
          l++;
        } while (l < fonts.length);
      }
      if (dynamicText[i].isCreative === false) {
        let filteredDynamicCreatives = filteredCreatives;
        if (dynamicText.length > 1) {
          const creativeDynamicTexts = dynamicText.slice(1, dynamicText.length);
          filteredDynamicCreatives = filteredCreatives.filter(creative => {
            if (!creativeDynamicTexts.some(cDynamicText => creative._id === cDynamicText.creativeId)) {
              return creative;
            }
          });
        }
        dispatch(updateCreativeFigmaFonts({
          creativeIds: filteredDynamicCreatives.map(item => item._id),
          fontsCss: fontCss
        }));
      } else if (dynamicText[i].isCreative === true) {
        const foundCreative = filteredCreatives.find(item => item._id === dynamicText[i].creativeId);
        if (foundCreative) {
          dispatch(updateCreativeFigmaFonts({
            creativeIds: [foundCreative._id],
            fontsCss: fontCss
          }));
        }
      }
      i++;
    } while (i < dynamicText.length);
    // dispatch(togglePluginLoader());
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const setPreviewFont = (font) => async (dispatch, getState) => {
  try {
    const { creatives, dynamicText, activeDynamicText } = getState().Campaign;
    if (activeDynamicText.isCreative === false) {
      let filteredCreatives = creatives;
      if (dynamicText.length > 1) {
        const creativeDynamicTexts = dynamicText.slice(1, dynamicText.length);
        filteredCreatives = creatives.filter(creative => {
          if (!creativeDynamicTexts.some(cDynamicText => creative._id === cDynamicText.creativeId)) {
            return creative;
          }
        });
      }
      let i = 0;
      do {
        filteredCreatives[i].preview.contentWindow.postMessage({
          action: "adc-set-font",
          font: font.outerHTML
        }, "*");
        i++;
      } while (i < filteredCreatives.length);

    } else if (activeDynamicText.isCreative === true) {
      const foundCreative = creatives.find(item => item._id === activeDynamicText.creativeId);
      if (foundCreative && foundCreative.preview.contentWindow) {
        foundCreative.preview.contentWindow.postMessage({
          action: "adc-set-font",
          font: font.outerHTML
        }, "*");
      }
    };
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
};

export const setPreviewFonts = () => async (dispatch, getState) => {
  try {
    const { creatives, dynamicText, filteredFontList } = getState().Campaign;
    const { brandPath } = getState().MenuData;
    let fonts = '';
    let i = 0;
    const fontLinkEls = await createLinkForDynamicTextFont(creatives, filteredFontList, brandPath);
    do {
      fonts += fontLinkEls[i].outerHTML;
      i++;
    } while (i < fontLinkEls.length);
    return fonts;
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const setHtmlCreativesPreview = createAsyncThunk('campaigns/setHtmlCreativesPreview', async (fonts, { dispatch, getState }) => {
  try {
    const { creatives, currentVersion, dynamicText, connectedFeed, previewFonts } = getState().Campaign;
    const updatedCreatives = [];
    let i = 0;
    do {
      const creative = creatives[i];
      let foundDynamicText = null;
      if (dynamicText.length > 0) {
        foundDynamicText = dynamicText.find(dItem => dItem.isCreative && dItem.creativeId === creative._id);
        if (!foundDynamicText) {
          foundDynamicText = dynamicText[0]
        }
      }
      const previewRes = await dispatch(createPreview(creative, currentVersion, foundDynamicText, connectedFeed, fonts));
      updatedCreatives.push({
        ...creative,
        preview: previewRes.preview
      });
      i++;
    } while (i < creatives.length);
    return updatedCreatives;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
});

// export const highlightDynamicTexts = (tag) => async (dispatch, getState) => {
//   try {
//     const { creatives, dynamicText, activeDynamicText } = getState().Campaign;
//     dispatch(removeHighlightDynamicTexts());
//     if (activeDynamicText?.isCreative === false) {
//       let filteredCreatives = creatives;
//       if (dynamicText.length > 1) {
//         const creativesDynamicText = dynamicText.slice(1, dynamicText.length);
//         filteredCreatives = creatives.filter(creative => {
//           if (!creativesDynamicText.some(cDynamicText => creative._id === cDynamicText.creativeId)) {
//             return creative;
//           }
//         });
//       }
//       let i = 0;
//       do {
//         filteredCreatives[i].preview.contentWindow.postMessage({
//           action: "adc-highlight-element",
//           tag: tag
//         }, "*");
//         i++;
//       } while (i < filteredCreatives.length);
//     } else if (activeDynamicText?.isCreative === true) {
//       const foundCreative = creatives.find(item => item._id === activeDynamicText.creativeId);
//       if (foundCreative) {
//         foundCreative.preview.contentWindow.postMessage({
//           action: "adc-highlight-element",
//           tag: tag
//         }, "*");
//       }
//     };
//   } catch (error) {

//   }
// }

export const highlightDynamicTexts = (item) => async (dispatch, getState) => {
  try {
    const { creatives, scrolledCreatives, selectedCreative, dynamicText, activeDynamicText } = getState().Campaign;
    dispatch(removeHighlightDynamicTexts());
    let filteredCreatives = scrolledCreatives;
    if (activeDynamicText.isCreative === false && !selectedCreative) {
      if (item.dynamicTextIdx === 0) {
        filteredCreatives = [];
        creatives.forEach(item => {
          if (!dynamicText.find(dItem => dItem.isCreative === true && dItem.creativeId === item._id)) {
            filteredCreatives.push(item);
          }
        })
        let filteredDynamicTexts = dynamicText.filter(dItem => dItem.texts.find(dText => dText.tag === item.tag && dText.value === item.value));
        filteredDynamicTexts = filteredDynamicTexts.filter(dItem => dItem.isCreative === true);
        if (filteredDynamicTexts.length > 0) {
          let i = 0;
          do {
            if (filteredDynamicTexts[i].isCreative) {
              const foundCreative = creatives.find(creative => creative._id === filteredDynamicTexts[i].creativeId);
              if (foundCreative) {
                filteredCreatives.push(foundCreative);
              }
            }
            i++;
          } while (i < filteredDynamicTexts);
        }
      } else {
        const creativeIds = [];
        let k = 0;
        do {
          const idx = item.dynamicTextIdxs[k];
          creativeIds.push(dynamicText[idx].creativeId);
          k++;
        } while (k < item.dynamicTextIdxs.length);
        let m = 0;
        const foundCreatives = [];
        do {
          const creativeId = creativeIds[m];
          const foundCreative = creatives.find(creative => creative._id === creativeId);
          if (foundCreative) {
            foundCreatives.push(foundCreative);
          }
          m++;
        } while (m < creativeIds.length);
        filteredCreatives = foundCreatives;
      }
    } else if ((activeDynamicText.isCreative === true) || selectedCreative) {
      let foundCreative = creatives.find(creative => creative._id === selectedCreative._id);
      if (!foundCreative) {
        foundCreative = selectedCreative;
      }
      filteredCreatives = [foundCreative];
    }
    if (filteredCreatives.length > 0) {
      let i = 0;
      do {
        if (filteredCreatives[i].preview && filteredCreatives[i].preview.contentWindow) {
          filteredCreatives[i].preview.contentWindow.postMessage({
            action: "adc-highlight-element",
            tag: item.tag
          }, "*");
        }
        i++;
      } while (i < filteredCreatives.length);
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const removeHighlightDynamicTexts = () => async (dispatch, getState) => {
  try {
    const { scrolledCreatives } = getState().Campaign;
    let i = 0;
    do {
      if (scrolledCreatives[i].preview) {
        scrolledCreatives[i].preview.contentWindow.postMessage({
          action: "adc-clear-highlight-elements"
        }, "*");
      }
      i++;
    } while (i < scrolledCreatives.length);
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const saveDynamicText = (isFeedDisconnect = false) => async (dispatch, getState) => {
  const { language } = getState().MenuData;
  try {
    const { currentVersion, creatives, isApplyAll, currentCampaign, dynamicText } = getState().Campaign;
    const { campaignPath } = getState().MenuData;
    let dynamicVideoErrorMsg = null;
    // const dynamicText = await dispatch(setFontCssBeforeSave());
    let checkedDynamicTexts = await dispatch(checkDynamicImageValue(dynamicText[0]));
    checkedDynamicTexts = await dispatch(checkDynamicVideoValue(dynamicText[0]));
    dynamicVideoErrorMsg = checkedDynamicTexts.dynamicVideoErrorMsg;
    let filteredDynamicTexts = { ...dynamicText[0], texts: checkedDynamicTexts.texts };
    const versionRes = await putDynamicText({
      id: dynamicText[0]._id,
      versionId: currentVersion._id,
      campaignId: campaignPath,
      texts: filteredDynamicTexts.texts,
      applyAll: isApplyAll
    });
    const updatedDynamicTexts = [{
      id: dynamicText[0]._id,
      versionId: currentVersion._id,
      campaignId: campaignPath,
      texts: filteredDynamicTexts.texts
    }];
    if (versionRes.status !== 'ok') {
      throw versionRes;
    }
    if (dynamicText.length > 1) {
      const creativesDynamicText = dynamicText.slice(1, dynamicText.length);
      let i = 0;
      do {
        if (creativesDynamicText[i]?.id || creativesDynamicText[i]?._id) {
          let checkedDynamicTexts = await dispatch(checkDynamicImageValue(creativesDynamicText[i]));
          checkedDynamicTexts = await dispatch(checkDynamicVideoValue(creativesDynamicText[i]));
          const creativeDynamicRes = await putDynamicText({
            id: creativesDynamicText[i]._id,
            campaignId: campaignPath,
            texts: checkedDynamicTexts.texts,
          });
          updatedDynamicTexts.push({
            ...creativesDynamicText[i],
            id: creativesDynamicText[i]._id,
            campaignId: campaignPath,
            texts: checkedDynamicTexts.texts,
          });
          if (creativeDynamicRes.status !== 'ok') {
            throw creativeDynamicRes;
          }
          if (checkedDynamicTexts.dynamicVideoErrorMsg) {
            dynamicVideoErrorMsg = checkedDynamicTexts.dynamicVideoErrorMsg;
          }
        } else {
          let checkedDynamicTexts = await dispatch(checkDynamicImageValue(creativesDynamicText[i]));
          checkedDynamicTexts = await dispatch(checkDynamicVideoValue(creativesDynamicText[i]));
          const createDynamicRes = await dispatch(createDynamicText({ ...creativesDynamicText[i], texts: checkedDynamicTexts.texts, campaignId: campaignPath, versionId: currentVersion._id }))
          if (createDynamicRes.status !== 'ok') {
            throw createDynamicRes;
          }
          if (checkedDynamicTexts.dynamicVideoErrorMsg) {
            dynamicVideoErrorMsg = checkedDynamicTexts.dynamicVideoErrorMsg;
          }
          updatedDynamicTexts.push({
            ...creativesDynamicText[i], texts: checkedDynamicTexts.texts, campaignId: campaignPath, versionId: currentVersion._id
          });
        }
        i++;
      } while (i < creativesDynamicText.length);
    }
    // await dispatch(setAllCreativesFont());
    if (isFeedDisconnect) {
      await dispatch(updateCreativeDynamicLoopAfterFeedDisconnectThunk());
    } else {
      const updatedCreatives = updateAllCreativesPoster(creatives, updatedDynamicTexts);
      const creativeRes = await putCreative({ creativeArray: updatedCreatives, campaignId: currentCampaign._id });
    }
    dispatch(setSelectedCreative(null));
    dispatch(setIsApplyAll(false));
    return dynamicVideoErrorMsg;
  } catch (error) {
    checkMaintenance(dispatch, error);
    toast.error(language[error?.code], { autoClose: 3000 });
  }
}

export const checkDynamicImageValue = (dynamicText) => async (dispatch, getState) => {
  try {
    const { client, clientPath, brandPath, campaignPath } = getState().MenuData;
    // PUT
    let texts = [];
    let i = 0;
    do {
      if (dynamicText.texts[i].type === "image") {
        if (dynamicText.texts[i].hasOwnProperty('file')) {
          // UPLOAD ASSET
          const uploadRes = await postUploadAsset({
            companyId: client._id,
            clientId: clientPath,
            brandId: brandPath,
            campaignId: campaignPath,
            files: dynamicText.texts[i].file,
            type: 'image',
          });
          let value = dynamicText.texts[i].value
          if (uploadRes.status === 'ok') {
            value = uploadRes.data[0][0];
          }
          texts.push({
            name: dynamicText.texts[i].name,
            tag: dynamicText.texts[i].tag,
            type: dynamicText.texts[i].type,
            value: value
          });
        } else {
          texts.push(dynamicText.texts[i]);
        }
      } else {
        texts.push(dynamicText.texts[i]);
      }
      i++;
    } while (i < dynamicText.texts.length);
    return { ...dynamicText, texts: texts };
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
};

export const checkDynamicVideoValue = (dynamicText) => async (dispatch, getState) => {
  try {
    const { client, clientPath, brandPath, campaignPath } = getState().MenuData;
    const { creatives } = getState().Campaign;
    let dynamicTextName = '';
    let dynamicVideoErrorMsg = null;
    if (dynamicText.isCreative) {
      const foundCreative = creatives.find(item => item._id === dynamicText.creativeId);
      if (foundCreative) {
        dynamicTextName = foundCreative.size;
      }
    }
    // PUT
    let texts = [];
    let i = 0;
    do {
      if (dynamicText.texts[i].type === "video") {
        let textObj = {
          name: dynamicText.texts[i].name,
          tag: dynamicText.texts[i].tag,
          type: dynamicText.texts[i].type,
          value: dynamicText.texts[i].value.includes('base64') ? '' : dynamicText.texts[i].value,
          poster: dynamicText.texts[i].poster.includes('base64') ? "" : dynamicText.texts[i].poster
        };
        if ((dynamicText.texts[i].value && dynamicText.texts[i].value.trim() !== '' && dynamicText.texts[i].poster && dynamicText.texts[i].poster.trim() !== '')
          || (dynamicText.texts[i].hasOwnProperty('file') && dynamicText.texts[i].hasOwnProperty('posterFile'))) {
          if (dynamicText.texts[i].hasOwnProperty('file') && dynamicText.texts[i].hasOwnProperty('posterFile')) {
            // UPLOAD ASSET
            const uploadRes = await postUploadAsset({
              companyId: client._id,
              clientId: clientPath,
              brandId: brandPath,
              campaignId: campaignPath,
              files: dynamicText.texts[i].file,
              type: 'video'
            });
            if (uploadRes.status === 'ok') {
              textObj.value = uploadRes.data[0][0];
            }
          }
          if (dynamicText.texts[i].hasOwnProperty('posterFile') && dynamicText.texts[i].hasOwnProperty('file')) {
            const uploadRes = await postUploadAsset({
              companyId: client._id,
              clientId: clientPath,
              brandId: brandPath,
              campaignId: campaignPath,
              files: dynamicText.texts[i].posterFile,
              type: 'image'
            });
            if (uploadRes.status === 'ok') {
              textObj.poster = uploadRes.data[0][0];
            }
          }
          texts.push(textObj);
        } else {
          let missingPart = '';
          if (!dynamicText.texts[i].value || !dynamicText.texts[i].file) {
            missingPart = 'video';
          } else if (!dynamicText.texts[i].poster || !dynamicText.texts[i].posterFile) {
            missingPart = 'poster';
          }
          // dispatch(setDynamicVideoError({
          //   dynamicVideoError: true,
          dynamicVideoErrorMsg = `${dynamicTextName} - ${dynamicText.texts[i].name} ${missingPart} missing.`
          // }));
          texts.push({ ...textObj, type: 'image' });
        }

      } else if (dynamicText.texts[i].type === 'image') {
        texts.push(dynamicText.texts[i]);
      } else {
        texts.push(dynamicText.texts[i]);
      }
      i++;
    } while (i < dynamicText.texts.length);
    return { ...dynamicText, texts: texts, dynamicVideoErrorMsg: dynamicVideoErrorMsg };
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
};

export const controlDynamicVideoError = () => async (dispatch, getState) => {
  try {
    const { dynamicText, creatives } = getState().Campaign;
    if (dynamicText.length > 0) {
      let i = 0;
      do {
        let texts = dynamicText[i].texts;
        let dynamicTextName = '';
        if (dynamicText[i].isCreative) {
          const foundCreative = creatives.find(item => item._id === dynamicText[i].creativeId);
          if (foundCreative) {
            dynamicTextName = foundCreative.size;
          }
        }
        if (texts.length > 0) {
          let k = 0;
          do {
            if (texts[k].type === 'video') {
              if (texts[k].poster && texts[k].poster !== '' && texts[k].poster !== ' ' && (!texts[k].value || texts[k].value === '' || texts[k].value === ' ')) {
                dispatch(setDynamicVideoError({
                  dynamicVideoError: true,
                  dynamicVideoErrorMsg: `${dynamicTextName} - ${texts[k].name} video missing.`
                }));
              } else if (texts[k].value && texts[k].value !== '' && texts[k].value !== ' ' && (!texts[k].poster || texts[k].poster === '' || texts[k].poster === ' ')) {
                dispatch(setDynamicVideoError({
                  dynamicVideoError: true,
                  dynamicVideoErrorMsg: `${dynamicTextName} - ${texts[k].name} poster image missing.`
                }));
              }
            }
            k++;
          } while (k < texts.length);
        }
        i++;
      } while (i < dynamicText.length);
    }

  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);

  }
}

export const getFontList = createAsyncThunk("dynamictext/getFontList", async (data, { dispatch, getState }) => {
  try {
    const { brandPath } = getState().MenuData;
    const res = await getFontListData({
      brandId: brandPath,
      family: ""
    });
    if (res.status === "ok") {
      return res.data;
    };
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
});

export const searchFontForDynamicText = (query) => async (dispatch, getState) => {
  try {
    const { brandPath } = getState().MenuData;
    const res = await getFontListData({
      brandId: brandPath,
      family: query
    });
    if (res.status === "ok") {
      // dispatch(setFilteredFontList(res.data));
      return res.data;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
};

export const getFontCss = (query) => async (dispatch, getState) => {
  try {
    // const searchRes = await dispatch(searchFontForDynamicText(query));
    // const res = await fetch(searchRes[0].preview.replace(/&text=[^&]*/, ''));
    const res = await fetch(query);
    if (res) {
      const text = await res.text();
      return text;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}

export const setFontCssBeforeSave = () => async (dispatch, getState) => {
  try {
    return new Promise(async (resolve) => {
      const { dynamicText, activeDynamicText, filteredFontList } = getState().Campaign;
      let dynamicTexts = [];
      const fontObj = {};
      let i = 0;
      do {
        dynamicTexts.push({ ...dynamicText[i], texts: [] });
        let a = 0;
        do {
          const text = dynamicText[i].texts[a];
          if (text.type === 'text') {
            let ffRegex;
            let key;
            if (text.isFeed) {
              key = "style";
              ffRegex = /font-family:\s*"([^&]+)";/g;
            } else {
              key = "value";
              ffRegex = /font-family:\s*&quot;([^&]+)&quot;/g;
            }
            let match;
            while ((match = ffRegex.exec(text[key])) !== null) {
              if (fontObj[match[1]]) {
              } else {
                const foundFont = filteredFontList.find(item => item.family === match[1]);
                if (foundFont) {
                  fontObj[match[1]] = await dispatch(getFontCss(foundFont.preview.replace(/&text=[^&]*/, '')));
                }
              }
            }
            dynamicTexts[i].texts.push({ ...text, fonts: Object.values(fontObj).join(" ") });
          } else {
            dynamicTexts[i].texts.push({ ...text });
          }
          a++;
        } while (a < dynamicText[i].texts.length);
        i++;
      } while (i < dynamicText.length);
      dispatch(setDynamicText(dynamicTexts));
      const foundDynamicText = dynamicTexts.find(item => item._id === activeDynamicText._id);
      dispatch(setActiveDynamicText(null));
      setTimeout(() => {
        dispatch(setActiveDynamicText(foundDynamicText));
      }, 1);
      resolve(dynamicTexts);
    });
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
};

export const getStylesFromCreativeObj = (tag) => (dispatch, getState) => {
  try {
    const { activeDynamicText, creatives } = getState().Campaign;
    let nodes, cssStr = '', fontFamilyCss, fontWeightCss, fontSizeCss, fontColorCss, bgColorCss, lineHeightCss;
    if (activeDynamicText.isCreative === false) {
      nodes = creatives[0].figmaObject.node;
    } else {
      const foundCreative = creatives.find(item => item._id === activeDynamicText.creativeId);
      if (foundCreative) {
        nodes = foundCreative.figmaObject.node;
      }
    }
    const nodeKeys = Object.keys(nodes);
    let i = 0;
    do {
      const key = nodeKeys[i];
      if (nodes[key].name && cleanString(nodes[key].name) === tag.replace('adc-', '') && nodes[key].type === 'TEXT') {
        fontFamilyCss = nodes[key].css['font-family'];
        fontWeightCss = nodes[key].css['font-weight'];
        fontSizeCss = nodes[key].css['font-size'];
        fontColorCss = (getStyleValue(`color: ${nodes[key].css['color']}`, 'color'));
        bgColorCss = (nodes[key].css['background-color'] ? nodes[key].css['background-color'] : 'transparent');
        lineHeightCss = nodes[key].css['line-height'];
        // if (activeDynamicText.isCreative === false) {
        //   fontSizeCss = 'auto';
        //   lineHeightCss = 'auto';
        // }
        // setFontFamily((fontFamilyCss ? fontFamilyCss : 'Poppins'));
        // setFontSize((fontSizeCss ? fontSizeCss : '14px'));
        // setFontWeight((fontWeightCss ? fontWeightCss : '400'));
        // setFontColor((fontColorCss ? fontColorCss : null));
        // setBgColor((bgColorCss ? bgColorCss : 'transparent'));
        // setLineHeight((lineHeightCss ? lineHeightCss : '21px'));

        cssStr = `
          font-family: ${fontFamilyCss};
          font-size: ${fontSizeCss};
          color: ${fontColorCss};
          background-color: ${bgColorCss};
          line-height: ${lineHeightCss};
          font-weight: ${fontWeightCss}
        `;
        break;
      }
      i++;
    } while (i < nodeKeys.length);
    return {
      fontFamilyCss,
      fontWeightCss,
      fontSizeCss,
      fontColorCss,
      bgColorCss,
      lineHeightCss,
      str: cssStr
    }
    // return cssStr;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

// export const checkCreativeFontUploaded = (filteredFontList) => async (dispatch, getState) => {
//   try {
//     const { creatives, fontNotUploadedName } = getState().Campaign;
//     let fontsUpdated = false;
//     let finalFonts = [];
//     if (creatives.length > 0 && filteredFontList.length > 0) {
//       let i = 0;
//       do {
//         const creative = creatives[i];
//         let creativesUpdatedFonts = creative.figmaObject.node.frame.fonts;
//         const creativeFonts = creative.figmaObject.node.frame.fonts.split('||');
//         // console.log(creativeFonts);

//         let k = 0;
//         do {
//           const fontName = creativeFonts[k].split(':')[0].replace('+', ' ');
//           console.log(creativeFonts[k].split(':')[0], fontName);

//           const fontVariant = creativeFonts[k].split(':')[2];
//           if (fontName && fontName !== '' && fontName !== ' ') {
//             const foundFont = filteredFontList.findIndex(item => item.family.toUpperCase().replaceAll('+', ' ').replaceAll(' ', '') === fontName.toUpperCase().replaceAll(' ', ''));
//             if (!filteredFontList[foundFont]) {
//               dispatch(setFontNotUploaded({
//                 fontNotUploaded: true,
//                 fontNotUploadedName: fontName
//               }));
//             } else if (filteredFontList[foundFont] && !filteredFontList.find(item => item.family === fontName)) {
//               finalFonts.push(creativesUpdatedFonts.replaceAll(fontName, filteredFontList[foundFont].family));
//               dispatch(updateCreativeNodeKeyFont({wrongName: fontName, trueName: filteredFontList[foundFont].family}));
//               fontsUpdated = true;
//             }
//           }
//           k++;
//         } while (k < creativeFonts.length);

//         i++;
//       } while (i < creatives.length);
//     }
//     return { fontsUpdated, finalFonts }
//   } catch (error) {
//     console.log(error);
//   }
// }

// export const updateCreativeSetFont = (finalFonts) => async (dispatch, getState) => {
//   try {
//     const { creatives, currentCampaign } = getState().Campaign;
//     const updatedCreatives = [];
//     let i = 0;
//     do {
//       let finalCreative = {...creatives[i]};
//       console.log('finalCreative', finalCreative);

//       finalCreative.figmaObject.node.frame.fonts = finalFonts[i]
//       updatedCreatives.push(finalCreative);
//       i++;
//     } while (i < creatives.length);
//     const res = await putCreative({ campaignId: currentCampaign._id, creativeArray: updatedCreatives });
//     if (res.status === 'err') {
//       throw res;
//     }
//     console.log(res);
//     await dispatch(openCampaign(currentCampaign));
//   } catch (error) {
//     console.log(error);

//   }
// }

export const updateVersionStatusAfterUpdate = (newPublishedVal = 1) => async (dispatch, getState) => {
  try {
    const { currentVersion, versions, currentCampaign } = getState().Campaign;
    if (currentVersion.published === 2) {
      const updatedVersion = { ...currentVersion, published: newPublishedVal };
      const updatedVersions = [];
      versions.forEach(item => {
        if (item._id === updatedVersion._id) {
          updatedVersions.push(updatedVersion);
        } else {
          updatedVersions.push(item)
        }
      });
      dispatch(setCurrentVersion(updatedVersion));
      dispatch(setVersions(updatedVersions));
      return { updatedVersion: updatedVersion, updatedVersions: updatedVersions };
    }
    return { updatedVersion: currentVersion, updatedVersions: versions };
  } catch (error) {
    checkMaintenance(dispatch, error);
  }
}